/* global EpgEnabled, MarketingCollectionEnabled */

import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import IdleTimer from 'react-idle-timer';
import { scroller, animateScroll, Element } from 'react-scroll';
import ReactTimeout from 'react-timeout';
import { Waypoint } from 'react-waypoint';
import classNames from 'classnames';
import VideoHero from 'components/VideoHero';
import Panel from 'components/Panel';
import Carousel from 'components/Carousel';
import Schema from 'componentsV2/Schema';
import { SCHEMA_TYPES } from 'componentsV2/Schema/SchemaHelper';
import BreadcrumbsComponent, { breadcrumbsCollectionParser } from 'components/Breadcrumbs';
import HomeSlideHeaderComp from 'components/HomeSlideHeader';
import HomeSlidePromoComp from 'components/HomeSlidePromo';
import Loader from 'components/Loader';
import LoaderCarousel from 'components/Carousel/LoaderCarousel';
import VideoModal from 'components/VideoModal';
import RedFastBanner from 'components/RedFastBanner';
import {
  FEATURED_BANNER_TOP,
  FEATURED_BANNER_2ND,
  FEATURED_BANNER_3RD,
  FEATURED_BANNER_4TH,
  LISTEN_BANNER_TOP,
  PERSONALITIES_BANNER_TOP,
  SHOWS_BANNER_TOP,
} from 'helpers/EngagementPlacements';
import { BrazeContentRender, BrazeFetchContent } from 'helpers/Braze';
import { saveLiveVideo, setSuggestedChannel } from 'screens/Live/LiveActions';
import { noop } from 'helpers/GlobalHelper';
import { helperGetApiHeaders, helperConvertApiRoute } from 'helpers/ApiHelper';
import {
  Events,
  getAdjacentCollectionAbove,
  getCollectionCount,
  getCollectionPosition,
  getNewRelicPageName,
  getRecommendationIdDataForItem,
  getSegmentBannerDimensions,
  getSegmentBannerType,
  getSegmentContentUidString,
  getSegmentModelMetadata,
  getSegmentPageCollectionIdList,
  getTealiumRedesignEvents,
  handleAnalytics,
  homeTabPageNames,
  PageNames,
  setOptimizelyCollectionViewedEvent,
  setTealiumSourceCollectionGlobal,
  trackPageReferrerAnalytics,
  updateSegmentBannerData,
} from '@foxcorp/delta-web-analytics';
import { logEvent } from 'helpers/LogReportHelpers';
import {
  calculateNextRefreshForPanel,
  canDisplayUpsell,
  DISPLAY_TYPE_DESTINATION,
  formatDirectUrl,
  FOX,
  getDisplayBrand,
  getErrorComponent,
  getNetworkLogoUrl,
  getRequiresAuth,
  getUrlTarget,
  getVideoIdFromUrl,
  isClip,
  isLive,
  isShowcase,
  isShowcaseCountdown,
  isSportsContent,
  isStaticRender,
  isTypePromo,
  isUpcomingContent,
  PANEL_TYPE_COUNTDOWN,
  PANEL_TYPE_PLAYER_BANNER,
  PANEL_TYPE_PROMOS,
  PANEL_TYPE_SHOWS,
  PANEL_TYPE_VIDEOS,
} from 'helpers/ContentHelper';
import { now, stringToDate, isBetween, differenceInMilliseconds } from 'helpers/DateTimeHelper';
import {
  COLLECTION_HERO_IMAGE,
  COLLECTION_THUMBNAIL_IMAGE,
  COUNTDOWN_BANNER_IMAGE,
  getDynamicImage,
  renderImage,
  SMALL_PROMO_IMAGE,
} from 'helpers/ImageHelper';
import {
  helperGetLiveUrl,
  helperGoToRelativeUrl,
  isHomeRoute,
  redirectToExternalUrl,
} from 'helpers/RouteHelper';
import { PAGE_COLLECTION } from 'helpers/PageHelper';
import {
  additionalPosterEnabled,
  autoplayEnabled,
  countdownBannerEnabled,
  heroCarouselEnabled,
  liveTileCollectionV2Enabled,
  strikeBannerEnabled,
  thumbnailNetworkLogoEnabled,
} from 'helpers/ConfigHelper';
import { PROMO_TYPE_INSET, PROMO_TYPE_LEAD } from 'helpers/SeriesDetailHelpers';
import {
  OVERLAY_HEADER_SEARCH,
  OVERLAY_ALL_COLLECTIONS,
  OVERLAY_VIDEO_MODAL,
} from 'helpers/FilterHelper';

import PubSub from 'helpers/PubSub';

import {
  getOptimizelyFakeCollectionData,
  userAttributeEvents as optimizelyUserAttributeEvents,
} from 'helpers/OptimizelyHelper';
import Seo from 'componentsV2/Seo';
import {
  isMobileBreakpoint,
  SITE_PLATFORM_MOBILE,
  SITE_PLATFORM_TABLET,
  SITE_PLATFORM_WEB_LARGE,
  SITE_PLATFORM_WEB,
  TABLET_LANDSCAPE_BREAKPOINT,
  DESKTOP_BREAKPOINT,
  XL_BREAKPOINT,
  defaultPosterResponsiveness,
} from 'helpers/BreakpointHelper';
import {
  homeCarouselVideoProcessor,
  homeLinkTileCarouselProcessor,
} from 'helpers/Processor/CarouselVideoProcessor';
import {
  clearVideo as removeGlobalVideoPlayer,
  saveLiveRestart as saveGlobalLiveRestart,
  setDisableRender as setGlobalVideoDisabled,
  setVideoPanel as setGlobalVideoPanel,
  setPlayerType as setGlobalPlayerType,
  setScreenInControlOfState as setGlobalPlayerScreenInControlOfState,
} from 'components/VideoPlayerGlobal/Actions';
import MarketingBanner from 'components/MarketingBanner';
import CountdownBanner from 'components/CountdownBanner';
import FloatingStartFreeTrial from 'components/FloatingStartFreeTrial';
import StrikeBanner, {
  STRIKE_PAGE_TYPE_HOME,
  STRIKE_PAGE_TYPE_SECTION_FRONT,
} from 'components/StrikeBanner';
import { PLAYER_TYPE_DEFAULT, PLAYER_TYPE_HERO } from 'helpers/PlayerHelper';
import { setRecommendationIdAction as setRecommendationId } from 'index/AppActions';
import SuccessModal from 'componentsV2/SuccessModal';
import CollectionCarousel from './components/Carousel';
import ChannelList from './components/ChannelList';
import CollectionTile from './components/CollectionTile';
import CollectionLinkTile from './components/CollectionLinkTile';
import HeroCarousel from './components/HeroCarousel';
import UpcomingModal from './components/UpcomingModal';
import VideoBanner from './components/VideoBanner';
import NationCollection from './CollectionStub.json';
import {
  clearCollectionPanels,
  fetchCollectionPanel,
  fetchCollections,
  incrementPanelRenderCount,
  resetPanelLoaded,
  resetPanelRenderCount,
  setUserBookmarks,
  setUseShowcaseFallback,
  updateCollectionOrder,
  updateVisibleElements,
} from './Actions';
import {
  addSeeMoreItem,
  didPanelsAvailabilityChange,
  featuredVideoProcessor,
  getCollectionIndex,
  getCollectionName,
  getCurrentShowcase,
  getMarketingVideoBanner,
  getTimeoutTime,
  shouldRenderDefaultPanel,
} from './Helpers';
import smallPromoStyle from './smallPromo.css';
import CarouselTileTheme from './CarouselTile.css';
import CarouselTheme from './Carousel.module.scss';
import GenreTileTheme from './GenreTile.module.scss';
import LatestEpisodes from './LatestEpisodes.css';
import {
  makeSelectInitialShowcase,
  makeSelectCollectionOrder,
  makeSelectCollectionPanels,
  makeSelectVisibleCollections,
  makeSelectPanelPanels,
  makeSelectGlobalVideoPanelVideo,
} from './selectors';
import CarouselPosterStyle from './CarouselPoster.module.scss';
import Style from './Collection.module.scss';

const ALL_COLLECTIONS_SCROLL_PREFIX = 'ALL_COLLECTIONS_SCROLL_PREFIX_';
const FETCH_COLLECTION_DEFAULT = 1000 * 60 * 5;
const FETCH_COLLECTION_MAX_PANELS_PREFETCH = 1000;
const SCROLL_DEBOUNCE_TIME = 200;
const isAdditionalPosterEnabled = additionalPosterEnabled();
let debouncedScroll;

export const BREAKPOINTS = (() => {
  const breakpoints = {
    [SITE_PLATFORM_WEB_LARGE]: {
      addCarouselPlaceholders: true,
      allowScrollLock: false,
      videoBackground: true,
      smallPromoImage: 'images.desktop-promo',
      allowInfoToggle: false,
      showLiveButtons: true,
      carouselLimit: 5,
      slidesToScroll: 5,
      posterLimit: 5,
      posterToScroll: isAdditionalPosterEnabled ? 6 : 5,
      descriptionLines: isAdditionalPosterEnabled ? 4 : 5,
      roundArrows: true,
      smallCollectionHeader: false,
      useSeriesLogo: true,
      showCarouselArrows: true,
      showTileMetadataOnHover: true,
      useMobileUpcomingOverlay: false,
      fycLogoHeight: 80,
      useScrollableDiv: false,
    },
    [SITE_PLATFORM_WEB]: {
      addCarouselPlaceholders: true,
      allowScrollLock: false,
      videoBackground: true,
      smallPromoImage: 'images.desktop-promo',
      allowInfoToggle: false,
      showLiveButtons: true,
      carouselLimit: 4,
      slidesToScroll: 4,
      posterLimit: 5,
      posterToScroll: isAdditionalPosterEnabled ? 6 : 5,
      descriptionLines: isAdditionalPosterEnabled ? 3 : 5,
      roundArrows: true,
      smallCollectionHeader: false,
      useSeriesLogo: true,
      showCarouselArrows: true,
      showTileMetadataOnHover: true,
      useMobileUpcomingOverlay: false,
      fycLogoHeight: 80,
      useScrollableDiv: false,
    },
    [SITE_PLATFORM_TABLET]: {
      addCarouselPlaceholders: true,
      allowScrollLock: false,
      videoBackground: true,
      smallPromoImage: 'images.desktop-promo',
      allowInfoToggle: true,
      showLiveButtons: true,
      carouselLimit: 2,
      slidesToScroll: 2,
      posterLimit: 3,
      posterToScroll: 3,
      descriptionLines: isAdditionalPosterEnabled ? 2 : 3,
      roundArrows: true,
      smallCollectionHeader: false,
      useSeriesLogo: true,
      showCarouselArrows: true,
      showTileMetadataOnHover: true,
      useMobileUpcomingOverlay: true,
      fycLogoHeight: 80,
      useScrollableDiv: false,
    },
    [SITE_PLATFORM_MOBILE]: {
      addCarouselPlaceholders: false,
      allowScrollLock: true,
      videoBackground: false,
      smallPromoImage: 'images.mobile-promo',
      allowInfoToggle: true,
      showLiveButtons: true,
      carouselLimit: 1.25,
      slidesToScroll: 1,
      posterLimit: 2.5,
      posterToScroll: 2,
      descriptionLines: 2,
      roundArrows: true,
      smallCollectionHeader: false,
      useSeriesLogo: true,
      showCarouselArrows: false,
      showTileMetadataOnHover: false,
      useMobileUpcomingOverlay: true,
      fycLogoHeight: 50,
      useScrollableDiv: true,
    },
  };

  return breakpoints;
})();
// TODO: Remove this when Collection Carousel is enabled
const USE_COLLECTION_CAROUSEL = false;
let isInitialized = false;

class Collection extends Component {
  constructor(props) {
    super(props);
    const { initialShowcase } = this.props;
    this.state = {
      activeSlide: 0,
      activeSlideBottoms: [],
      activeSlideTops: [],
      collectionInterval: null,
      isEmptyPanelsFetched: false,
      lastActiveSlide: 0,
      leapfrogEventTriggered: false,
      liveItemId: null,
      load: true,
      loadedAnalytics: false,
      newRelicStart: false,
      numPanelsRendered: 3,
      overlayItemProps: null,
      persistGlobalVideoAfterUnmount: false,
      play: true,
      renderedPanels: {},
      shouldFetchMore: false,
      shouldRenderCountdown: true,
      shouldRenderVideoModal: false,
      showcase: initialShowcase || null,
      showcaseTimeout: {},
      userViewedPlayerBanner: false,
      videoModalData: null,
      videoModalId: null,
    };
    this.hiddenPanels = new Set();
    this.trackPageReferrerAnalytics = trackPageReferrerAnalytics.bind(this);
    this.refreshCollection = this.refreshCollection.bind(this);
    this.ignoreUnmountReferrerAnalytics = false;
    this.renderTileCarousel = USE_COLLECTION_CAROUSEL
      ? this.renderCollectionTileCarousel
      : this.renderTileCarousel;
  }

  componentDidMount() {
    const {
      canIAutoplay,
      getUseUtagGlobal,
      initialShowcase,
      location,
      openForgotPassword,
      pageViewEvent,
      profileBookmarks,
      panels,
      params,
      route,
      setGlobalPlayerScreenInControlOfState,
      setHomePage,
      setOverlay,
      setRecommendationId,
    } = this.props;
    const { isForgotPassword } = route;
    const { network, collectionId } = params;
    const pathName = _.get(location, 'pathname');
    const screenName = _.get(route, 'path');
    const newRelicPageName = getNewRelicPageName(pathName, params);
    const openFind = _.includes(_.get(window, 'location.pathname', ''), '/find');
    const commonNetworks = [FOX];
    if (setHomePage) setHomePage(true);
    if (isForgotPassword && openForgotPassword) openForgotPassword(commonNetworks, network);
    if (!isStaticRender() && (!isInitialized || screenName?.includes('local'))) {
      isInitialized = true;
      this.fetchCollectionData({ shouldFetch: true });
    }
    if (panels && collectionId) {
      this.scrollToCollection(panels, collectionId);
    } else {
      animateScroll.scrollToTop();
    }

    setUserBookmarks({ profileBookmarks });
    setRecommendationId();
    if (canIAutoplay) this.activateAutoplay(panels);
    if (openFind) setOverlay(OVERLAY_HEADER_SEARCH);
    if (autoplayEnabled()) {
      const source = PAGE_COLLECTION;
      setGlobalPlayerScreenInControlOfState(source);
    }
    this.updateShowcaseTimeout();
    logEvent(`on${newRelicPageName}ScreenStart`);
    logEvent(`on${newRelicPageName}ScreenView`);
    this.setState({ showcase: initialShowcase, newRelicStart: true });

    if (panels) {
      const panelExperimentData = _.get(panels, 'experimentData', null);
      const path = _.get(location, 'pathname');
      const currentCollectionPageName = path?.includes('featured')
        ? 'home'
        : path?.replace(/\//g, '');
      const pageName = homeTabPageNames[currentCollectionPageName];

      PubSub.publish('PAGE_LOADED');

      pageViewEvent({
        collection: panels,
        pageName,
        pageType: currentCollectionPageName,
        useUtagGlobal: getUseUtagGlobal(),
        panelExperimentData,
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      accessToken,
      analyticsLoaded,
      authCheckComplete,
      canIAutoplay,
      deviceId,
      firstIdentifyCall,
      overlay,
      panels: prevPanels,
      panelVideo,
      removeGlobalVideoPlayer,
      setHomePage,
      setUseShowcaseFallback,
      fetchCollectionPanel,
      isPanelLoaded,
    } = this.props;
    const {
      authCheckComplete: nextAuthCheckComplete,
      authSuccess: nextAuthSuccess,
      canIAutoplay: nextCanIAutoplay,
      overlay: nextOverlay,
      firstIdentifyCall: nextFirstIdentifyCall,
      panels,
    } = nextProps;
    const { isEmptyPanelsFetched } = this.state;
    const panelData = panels?.member;
    if (panelData?.length && !isEmptyPanelsFetched) {
      panelData.forEach(panel => {
        const panelItems = panel?.items?.member;
        const isPanelEmpty = panelItems?.length === 0;
        if (isPanelEmpty && !isPanelLoaded) {
          fetchCollectionPanel(panel, accessToken, deviceId);
        }
      });
      this.setState({ isEmptyPanelsFetched: true });
    }
    const { loadedAnalytics } = this.state;
    if (canIAutoplay && nextCanIAutoplay && !prevPanels && panels) this.activateAutoplay(panels);
    if (setHomePage) setHomePage(true);
    if (overlay === OVERLAY_VIDEO_MODAL && nextOverlay !== overlay) {
      this.toggleVideoModal({ preventScroll: true });
    }
    const identifyEventHasFired = !firstIdentifyCall && nextFirstIdentifyCall;
    if (analyticsLoaded && !loadedAnalytics && identifyEventHasFired) {
      this.setState({ loadedAnalytics: true });
    }

    const requiresAuth = getRequiresAuth({ video: panelVideo });
    const shouldUseShowcaseFallback =
      autoplayEnabled() &&
      !nextAuthSuccess &&
      nextAuthCheckComplete &&
      !authCheckComplete &&
      requiresAuth;
    if (shouldUseShowcaseFallback) {
      removeGlobalVideoPlayer({ source: PAGE_COLLECTION });
      setUseShowcaseFallback(true);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      accessToken,
      account,
      clearCollectionPanels,
      getUseUtagGlobal,
      initialShowcase,
      isFreemium,
      location,
      pageViewEvent,
      panels,
      resetPanelRenderCount,
      setGlobalVideoPanel,
      showcaseFallback,
      useShowcaseFallback,
    } = this.props;
    const {
      accessToken: prevAccessToken,
      account: prevAccount,
      initialShowcase: prevInitialShowcase,
      location: prevLocation,
      panels: prevPanels,
      useShowcaseFallback: prevUseShowcaseFallback,
    } = prevProps;
    const { leapfrogEventTriggered } = this.state;
    let didTriggerLeapfrogEvent = leapfrogEventTriggered;
    this.checkForLiveContent();
    const accessTokenChanged = prevAccessToken !== accessToken;
    const accountChanged = !prevAccount && account;
    const path = _.get(location, 'pathname');
    const prevPath = _.get(prevLocation, 'pathname');
    const pathChanged = path !== prevPath;
    const shouldRefreshData = accessTokenChanged || accountChanged || pathChanged;
    const panelsHavePopulated = !prevPanels && panels;
    const prevMember = _.get(prevPanels, 'member', []);
    const member = _.get(panels, 'member', []);
    const firstMember = _.get(member, '0.items.member', []);
    window.onpopstate = () => {
      clearCollectionPanels();
      this.fetchCollectionData({ shouldFetch: true });
    };
    if (shouldRefreshData) {
      this.fetchCollectionData();
      this.fetchCollectionInterval();
    }
    const showcasesAvailabilityChanged = didPanelsAvailabilityChange(prevMember, member);
    const currentCollectionPageName = path?.includes('featured')
      ? 'home'
      : path?.replace(/\//g, '');
    if (showcasesAvailabilityChanged) this.updateShowcaseTimeout();
    if (pathChanged) {
      clearCollectionPanels();
      this.fetchCollectionData({ shouldFetch: true });
      didTriggerLeapfrogEvent = false;
      this.setState({
        leapfrogEventTriggered: didTriggerLeapfrogEvent,
        renderedPanels: {},
        numPanelsRendered: 3,
      });
      resetPanelRenderCount();
    }
    if (prevInitialShowcase !== initialShowcase) {
      this.setState({ showcase: initialShowcase });
    }
    if (this.pageCollectionLength && !didTriggerLeapfrogEvent) {
      this.trackCollectionItems({
        collections: this.viewedCollections,
        event: Events.COLLECTION_ITEMS_RENDERED,
        pageType: currentCollectionPageName,
        path: prevPath,
      });
      this.hiddenPanels = new Set();
      this.viewedCollections = new Map();
      const panelExperimentData = _.get(panels, 'experimentData', null);
      const pageName = homeTabPageNames[currentCollectionPageName];

      pageViewEvent({
        collection: panels,
        isFreemium,
        pageName,
        pageType: currentCollectionPageName,
        panelExperimentData,
        useUtagGlobal: getUseUtagGlobal(),
      });

      handleAnalytics({
        event: Events.TOP_LEVEL_SECTION_LANDING,
        payload: {
          pageCollectionLength: this.pageCollectionLength,
          pageName: `home:landing`,
          pageType: currentCollectionPageName,
        },
      });

      this.setState({ leapfrogEventTriggered: true });
    }
    if (panelsHavePopulated) {
      const {
        params: { collectionId },
      } = this.props;
      this.fetchCollectionInterval();
      if (collectionId) {
        this.scrollToCollection(panels, collectionId);
      }

      this.trackCollectionItems({
        collections: panels?.member,
        event: Events.COLLECTION_ITEMS_AVAILABLE,
        path,
      });
    }
    if (!prevUseShowcaseFallback && useShowcaseFallback && showcaseFallback) {
      if (autoplayEnabled()) {
        if (!heroCarouselEnabled() || (heroCarouselEnabled() && firstMember.length === 1)) {
          setGlobalVideoPanel({ panel: showcaseFallback, source: PAGE_COLLECTION });
        }
      }
    }
    if (!this.brazeContent) {
      this.brazeContent = BrazeFetchContent();
    }
    return null;
  }

  componentWillUnmount() {
    const {
      location,
      setHomePage,
      setGlobalVideoDisabled,
      removeGlobalVideoPlayer,
      clearCollectionPanels,
    } = this.props;
    const { persistGlobalVideoAfterUnmount } = this.state;
    const { pathname = '' } = location;
    isInitialized = false;
    if (autoplayEnabled() && !persistGlobalVideoAfterUnmount) {
      const source = PAGE_COLLECTION;
      removeGlobalVideoPlayer({ source: PAGE_COLLECTION });
      setGlobalVideoDisabled({ value: true, source });
    }

    if (setHomePage) setHomePage(false);

    if (!this.ignoreUnmountReferrerAnalytics) {
      this.trackPageReferrerAnalytics({
        name: PageNames.HOME,
      });
    }
    clearCollectionPanels();
    this.trackCollectionItems({
      collections: this.viewedCollections,
      event: Events.COLLECTION_ITEMS_RENDERED,
      path: pathname,
    });
  }

  trackCollectionItems = ({ collections = [], path, event }) => {
    if (isHomeRoute(path)) {
      const isAvailableEvent = event === Events.COLLECTION_ITEMS_AVAILABLE;
      const pageRecsCollections = {};
      if (isAvailableEvent) {
        const modelIdList = [];
        const requestIdList = [];
        const resultSetIdList = [];
        const sourceIdList = [];
        collections?.forEach(collection => {
          const items = collection?.items?.member || [];
          items?.forEach(item => {
            const modelMetaData = item?.trackingData?.properties?.modelMetaData;
            modelIdList.push(modelMetaData?.modelId ?? '');
            requestIdList.push(modelMetaData?.requestId ?? '');
            resultSetIdList.push(modelMetaData?.resultSetId ?? '');
            sourceIdList.push(modelMetaData?.sourceId ?? '');
          });
        });
        pageRecsCollections.page_recs_collection_model_id_list = modelIdList.toString();
        pageRecsCollections.page_recs_collection_request_id_list = requestIdList.toString();
        pageRecsCollections.page_recs_collection_result_set_id_list = resultSetIdList.toString();
        pageRecsCollections.page_recs_collection_source_id_list = sourceIdList.toString();
      }
      if (
        (isAvailableEvent && !this.availableEventTriggered) ||
        (!isAvailableEvent && this.availableEventTriggered)
      ) {
        handleAnalytics({
          event,
          payload: {
            ...(isAvailableEvent && pageRecsCollections),
            page_collection_id_list: getSegmentPageCollectionIdList(
              Array.from(collections.values()),
              event,
            ),
            ...getSegmentModelMetadata(),
          },
        });

        if (!this.availableEventTriggered) {
          const idx = 0;

          if (!this.viewedCollections) this.viewedCollections = new Map();

          this.viewedCollections.set(idx, {
            contentUids: getSegmentContentUidString(collections[idx]),
            id: collections[idx]?.id,
            idx,
          });

          this.availableEventTriggered = true;
        }
      }
    } else if (this.availableEventTriggered) this.availableEventTriggered = null;
  };

  updateShowcaseTimeout = () => {
    const { showcaseTimeout } = this.state;
    const { showcaseId: savedShowcaseId, timeout, timeoutTime: savedTimeoutTime } = showcaseTimeout;
    const {
      clearTimeout,
      panels,
      setTimeout,
      removeGlobalVideoPlayer,
      setGlobalVideoPanel,
      setUseShowcaseFallback,
    } = this.props;
    // get showcase that has an available date the same as expiration
    // if one is not available, grab the next available showcase
    // if that is not available, grab the first showcase that is not timely
    const member = _.get(panels, 'member', []);
    const firstMember = _.get(member, '0.items.member', []);
    const showcase = getCurrentShowcase(member);
    const timeoutTime = getTimeoutTime(showcase, member);
    const showcaseId = _.get(showcase, 'id');
    const showcaseChanged = showcaseId !== savedShowcaseId;
    const timeoutTimeChanged = timeoutTime !== savedTimeoutTime;
    const shouldUpdateTimeout = showcaseChanged || timeoutTimeChanged;

    const newState = {};
    if (showcaseChanged) {
      newState.showcase = showcase;
      if (autoplayEnabled()) {
        if (!heroCarouselEnabled() || (heroCarouselEnabled() && firstMember.length === 1)) {
          const source = PAGE_COLLECTION;
          removeGlobalVideoPlayer({ source });
          setGlobalVideoPanel({ panel: showcase, source });
        }
      }
      setUseShowcaseFallback(false);
    }

    if (shouldUpdateTimeout) {
      if (timeout) {
        clearTimeout(timeout);
      }
      if (timeoutTime) {
        const newTimeout = setTimeout(
          this.updateShowcaseTimeout,
          differenceInMilliseconds(stringToDate(timeoutTime), now()),
        );
        const nextShowcaseTimeout = {
          showcaseId,
          timeout: newTimeout,
          timeoutTime,
        };
        newState.showcaseTimeout = nextShowcaseTimeout;
      } else {
        newState.showcaseTimeout = {};
      }
    }

    if (!_.isEmpty(newState)) this.setState(newState);
  };

  updatePersistGlobalVideoAfterUmount = (newVal, url) => {
    const { router, setGlobalPlayerType } = this.props;
    this.setState({ persistGlobalVideoAfterUnmount: newVal }, () => {
      setGlobalPlayerType(PLAYER_TYPE_DEFAULT);
      router.push(url);
    });
  };

  onIdle = () => {
    const { firstCollectionImpression } = this.props;
    // add to state if the function has been called
    if (!firstCollectionImpression) {
      this.callCollectionImpressionEvent();
    }
  };

  onSignUpClick = () => {
    const signUpUrl = _.get(window.ExternalConfig, 'externalSignUpUrl');
    if (signUpUrl) redirectToExternalUrl(signUpUrl);
  };

  getHeroImage(heroData, isPromo) {
    const { breakpoint } = this.props;
    const { videoBackground } = BREAKPOINTS[breakpoint];
    const hero = isTypePromo(_.get(heroData, '@type'))
      ? _.get(heroData, 'videos.0', heroData)
      : heroData;
    const promoImage = _.get(heroData, 'images.promoImage');
    if (!hero) return null;
    if (isShowcaseCountdown(heroData)) return heroData?.eventData?.keyArt?.seriesDetail;
    if (isPromo && promoImage) return promoImage;
    if (videoBackground) return _.get(hero, 'autoPlayStill.default.url');

    const path =
      _.get(hero, 'autoPlayStill.default.url') ||
      _.get(hero, 'images.raw') ||
      _.get(hero, 'images.still.raw') ||
      _.get(hero, 'images.seriesList.raw');

    return path;
  }

  setActiveSlide = () => {
    const { activeSlideTops, activeSlideBottoms, activeSlide } = this.state;
    const { panels } = this.props;
    if (!panels) return;
    const activeSlideTop = Math.min(...activeSlideTops);
    const activeSlideBottom = Math.min(...activeSlideBottoms);
    let nextActiveSlide = Math.min(activeSlideTop, activeSlideBottom);
    const play = activeSlideBottom >= activeSlideTop;
    if (nextActiveSlide === Infinity) nextActiveSlide = activeSlide;
    this.setState({
      activeSlideTops,
      activeSlide: nextActiveSlide,
      play,
    });
  };

  setRecommendationIdOnClick = (items, selectedItem) => {
    const { setRecommendationId } = this.props;
    const recommendationIdData = getRecommendationIdDataForItem(items, selectedItem);
    setRecommendationId(recommendationIdData);
  };

  activateAutoplay = panels => {
    const { setGlobalVideoDisabled } = this.props;
    const member = _.get(panels, 'member', []);
    const firstMember = _.get(member, '0.items.member', []);
    if (autoplayEnabled()) {
      if (!heroCarouselEnabled() || (heroCarouselEnabled() && firstMember.length === 1)) {
        const playerType = PLAYER_TYPE_HERO;
        const source = PAGE_COLLECTION;
        setGlobalVideoDisabled({ value: false, source, playerType });
      }
    }
  };

  callCollectionImpressionEvent = () => {
    const { collectionImpressionCalled, account, visibleCollections } = this.props;
    getTealiumRedesignEvents({ account }).collectionImpression({ visibleCollections });
    collectionImpressionCalled();
  };

  handleWaypointEntryAnalytics = ({ anonymousId, featuredTitle, headline, idx, panel, panels }) => {
    if (!this.viewedCollections.has(idx)) {
      const position = getCollectionPosition(panels, idx, headline);

      setOptimizelyCollectionViewedEvent({
        anonymousId,
        featuredTitle,
        panelId: panel.id,
        position: position - 1,
      });

      this.viewedCollections.set(idx, {
        contentUids: getSegmentContentUidString(panel),
        id: panel.id,
        idx,
      });
    }
  };

  handleSaveLiveRestart = ({ video }) => {
    const { saveGlobalLiveRestart } = this.props;
    saveGlobalLiveRestart(video);
  };

  selectPanelRenderer = (boundProps, panel) => {
    const { breakpoint, showcaseFallback, updateCollectionOrder, useShowcaseFallback } = this.props;
    const { idx, isFirst } = boundProps;
    const { showcase, panelsRendered } = this.state;
    const currentShowcaseId = _.get(showcase, 'id');
    const displayTemplate = _.get(panel, 'displayTemplate');
    const isChannel = displayTemplate === DISPLAY_TYPE_DESTINATION;
    const panelType = _.get(panel, 'panelType');
    const panelId = _.get(panel, 'id');
    const collectionType = _.get(panel, 'collectionType');
    const defaultPanelTypes = [
      'becauseYouWatched',
      'categorylist',
      'content',
      'showcaseItem',
      'shows',
      'trending',
      'trendingForYou',
      'videos',
    ];
    const isDefaultPanel = _.includes(defaultPanelTypes, panelType);
    const isShowcaseFallback = collectionType === 'showcase-fallback';
    const isShowcaseType = isShowcase(panel);
    if (isDefaultPanel && !isShowcaseFallback && !isChannel) {
      const isCurrentShowcase = currentShowcaseId && currentShowcaseId === panelId;
      const swapWithFallback = useShowcaseFallback && isShowcaseType && showcaseFallback;
      const preventShowcaseRender = isShowcaseType && !isCurrentShowcase;
      const panelToRender = swapWithFallback ? showcaseFallback : panel;
      // if not using fallback, remove id from panel order
      if (!swapWithFallback && !preventShowcaseRender) updateCollectionOrder(showcaseFallback);
      const shouldRenderPanel = shouldRenderDefaultPanel(panelToRender, updateCollectionOrder);
      if (!shouldRenderPanel || preventShowcaseRender) {
        this.hiddenPanels.add(panelId);
        return null;
      }

      const renderParams = { panel: panelToRender, idx, isFirst };

      if (heroCarouselEnabled())
        return isFirst
          ? this.renderPanelHeroV2(renderParams)
          : this.defaultPanelRendererV2(renderParams);
      return this.defaultPanelRenderer(renderParams);
    }
    if (isChannel && panel.items.member.length > 0) {
      return (
        <ChannelList
          breakpoint={breakpoint}
          collectionLength={this.pageCollectionLength}
          panel={panel}
          verticalPosition={idx + 1}
        />
      );
    }

    if (collectionType === PANEL_TYPE_COUNTDOWN) {
      return this.renderCountdownBanner({ panel, idx });
    }

    if (panelType === PANEL_TYPE_PROMOS) {
      // do not include promos in panel order, only collection items
      updateCollectionOrder(panel);
      const item = _.get(panel, 'items.member.0');
      const promoType = _.get(item, 'promoType');
      if (promoType === PROMO_TYPE_LEAD) {
        return this.renderLargePromo(boundProps, item);
      }
      if (promoType === PROMO_TYPE_INSET) {
        return this.renderSmallPromo(boundProps, item);
      }
      if (promoType === 'genre') {
        return this.genrePanelRenderer({ panel, idx });
      }
    }

    if (collectionType === PANEL_TYPE_PLAYER_BANNER) {
      return this.renderVideoBanner({ panel, idx });
    }

    if (getMarketingVideoBanner(panel)) {
      return this.renderMarketingVideoBanner({ panel, idx });
    }

    if (!panelsRendered) this.setState({ panelsRendered: true });

    return null;
  };

  toggleUpcomingOverlay = clickedItem => {
    const { upcomingOverlayOpen } = this.props;
    const item = _.get(clickedItem, 'originalItem');
    if (isUpcomingContent(item)) {
      this.setState({ overlayItemProps: clickedItem });
      upcomingOverlayOpen(true);
    }
  };

  toggleVideoModal = (opts = {}) => {
    const { url, videoData, panelIdx, preventScroll } = opts;
    const { shouldRenderVideoModal: prevShouldRender, lastActiveSlide } = this.state;
    const { setOverlay, panels } = this.props;
    if (prevShouldRender) {
      this.setState({
        lastActiveSlide: 0,
        shouldRenderVideoModal: false,
        videoModalId: null,
        videoModalData: null,
      });
      setOverlay(OVERLAY_VIDEO_MODAL, false);
      const activeCollectionId = _.get(panels, `member.${lastActiveSlide}.id`, null);
      if (activeCollectionId && !preventScroll) this.scrollToCollection(panels, activeCollectionId);
    } else {
      const videoId = getVideoIdFromUrl(url);
      this.setState(
        {
          lastActiveSlide: panelIdx,
          shouldRenderVideoModal: true,
          videoModalId: videoId,
          videoModalData: videoData,
        },
        () => {
          setOverlay(OVERLAY_VIDEO_MODAL);
        },
      );
    }
  };

  updateVisibleSlides = (prevSlideIndex, nextSlideIndex, panel, isHalfWay) => {
    // Called upon carousel click
    const {
      account,
      breakpoint,
      disableScroll,
      updateVisibleElements,
      visibleCollections,
    } = this.props;
    const { shouldFetchMore } = this.state;
    const { allowScrollLock, carouselLimit } = BREAKPOINTS[breakpoint];

    if (isHalfWay && !shouldFetchMore) {
      this.setState({
        shouldFetchMore: true,
      });
    }

    if (allowScrollLock) {
      disableScroll({ disableScroll: true, bodyOnly: true });
    }

    // Call Collection Impression Event on Carousel Click
    getTealiumRedesignEvents({ account }).collectionImpression({ visibleCollections });

    // Update new visible items
    const collectionLength = _.get(panel, 'items.totalItems');
    const headline = _.get(panel, 'headline');
    let firstSlideIdx = nextSlideIndex;
    let lastSlideIdx = nextSlideIndex + carouselLimit;
    if (lastSlideIdx > collectionLength) {
      lastSlideIdx = collectionLength;
      firstSlideIdx = collectionLength - carouselLimit;
    }
    const currentVisibleCollections = visibleCollections;
    const slideCollectionItems = _.get(panel, 'items.member');
    const slideRange = [
      Math.min(firstSlideIdx, lastSlideIdx),
      Math.max(firstSlideIdx, lastSlideIdx),
    ];
    const currentVisibleSlideItems = slideCollectionItems.slice(slideRange[0], slideRange[1]);
    _.forEach(currentVisibleSlideItems, (item, index) => {
      const slideItem = item;
      slideItem.slideIndex = index + slideRange[0];
    });
    if (currentVisibleCollections[headline]) {
      currentVisibleCollections[headline].items = currentVisibleSlideItems;
      currentVisibleCollections[headline].slideRange = slideRange;
    }
    updateVisibleElements(currentVisibleCollections);
  };

  refreshData = () => {
    const isTabOnFocus = _.get(document, 'visibilityState') === 'visible';
    if (!isTabOnFocus) return;
    const { location, params } = this.props;
    const pathName = _.get(location, 'pathname');
    const newRelicPageName = getNewRelicPageName(pathName, params);
    logEvent(`on${newRelicPageName}ScreenStart`);
    logEvent(`on${newRelicPageName}ScreenView`);
    this.fetchCollectionData();
  };

  handleSlideChangeBottom(idx, inRange) {
    const { activeSlideBottoms } = this.state;
    const slideIndex = activeSlideBottoms.indexOf(idx);
    if (inRange && slideIndex < 0) {
      activeSlideBottoms.push(idx);
    } else if (!inRange && slideIndex >= 0) {
      activeSlideBottoms.splice(slideIndex, 1);
    }
    if (debouncedScroll) debouncedScroll.cancel();
    debouncedScroll = _.debounce(this.setActiveSlide, SCROLL_DEBOUNCE_TIME);
    debouncedScroll();
  }

  handleSlideChangeTop = (idx, inRange) => {
    const { activeSlideTops } = this.state;
    const slideIndex = activeSlideTops.indexOf(idx);
    if (inRange && slideIndex < 0) {
      activeSlideTops.push(idx);
    } else if (!inRange && slideIndex >= 0) {
      activeSlideTops.splice(slideIndex, 1);
    }
    if (debouncedScroll) debouncedScroll.cancel();
    debouncedScroll = _.debounce(this.setActiveSlide, SCROLL_DEBOUNCE_TIME);
    debouncedScroll();
  };

  isLoading() {
    const { panels } = this.props;
    return (
      !panels || !panels.member || panels.length === 0 || panels['@id'].includes('local-affiliates')
    );
  }

  refreshCollection() {
    const {
      accessToken,
      account,
      deviceId,
      fetchCollections,
      location,
      params,
      route,
      updateVisibleElements,
    } = this.props;
    const path = route?.screenUrl;
    const screenName = route?.path;
    fetchCollections({
      accessToken,
      account,
      deviceId,
      panelsToPrefetch: 2,
      path,
      screenName,
    });
    updateVisibleElements({});
    const pathName = _.get(location, 'pathname');
    const newRelicPageName = getNewRelicPageName(pathName, params);
    logEvent(`on${newRelicPageName}ScreenStart`);
    logEvent(`on${newRelicPageName}ScreenView`);
  }

  checkForLiveContent() {
    const { liveItemId } = this.state;

    // only the first slide on the first panel should trigger the page to scroll to the top.
    const firstItem = _.get(this.props, 'panels.member.0.items.member.0', null);
    if (!firstItem) return;

    const { '@id': id, playerScreenUrl, livePlayerScreenUrl, startDate, endDate } = firstItem;

    if (liveItemId === id) return;

    if (playerScreenUrl && livePlayerScreenUrl && startDate && endDate) {
      const currentDate = now();
      const starts = stringToDate(startDate);
      const ends = stringToDate(endDate);

      const isLive = isBetween(currentDate, starts, ends);
      if (!isLive) return;

      // first item is live, scroll to top.
      this.setState({ liveItemId: id }, () => {
        animateScroll.scrollToTop();
      });
    }
  }

  scrollToCollection(panels, collectionId) {
    const { clearInterval, setInterval } = this.props;
    const decodedCollectionId = _.toLower(decodeURIComponent(collectionId));
    if (!panels) return;
    const collectionLocalIndex = _.findIndex(panels.member, o => {
      const { id, name, headline } = o;
      const isIdMatch = id === collectionId;
      const isNameMatch = _.toLower(name) === decodedCollectionId;
      const isHeadlineMatch = _.toLower(headline) === decodedCollectionId;
      return isIdMatch || isNameMatch || isHeadlineMatch;
    });
    const scrollElement = `${ALL_COLLECTIONS_SCROLL_PREFIX}${collectionLocalIndex}`;
    const interval = setInterval(() => {
      if (document.getElementsByName(scrollElement)[0]) {
        scroller.scrollTo(scrollElement, { offset: -110 });
        clearInterval(interval);
      }
    }, 1000);
  }

  defaultPanelRenderer({ panel, idx, isFirst }) {
    const {
      accessToken,
      anonymousId,
      breakpoint,
      collectionOrder,
      coordinates,
      forceKeyartForShowcase,
      globalVideoStartedPlayback,
      isAuthenticated,
      overlay,
      panels,
      preauthorizedResources,
      removeVideoHero,
      removeGlobalVideoPlayer,
      router,
      saveLiveVideo,
      setCoordinates,
      setSuggestedChannel,
      setOverlay,
      setVideoHero,
      streamExit,
      updateVisibleElements,
      videoIsLive,
      visibleCollections,
    } = this.props;

    const categoryType = panels?.categoryType;
    const { activeSlide, play, load } = this.state;
    const {
      allowInfoToggle,
      carouselLimit,
      showLiveButtons,
      showTileMetadataOnHover,
      smallCollectionHeader,
      useSeriesLogo,
    } = BREAKPOINTS[breakpoint];

    const {
      id: panelId,
      headline,
      images,
      items,
      collectionCTA,
      collectionType,
      name: collectionName,
    } = panel;
    if (!items) return null;
    const totalItems = _.get(items, 'totalItems');
    let originalFirstItem = _.get(items, 'member.0');
    if (!originalFirstItem) return null;
    if (originalFirstItem.items) {
      originalFirstItem = _.get(originalFirstItem, 'items.member.0', originalFirstItem);
    }
    const isSeriesPromo = collectionType === 'seriespromo';
    const firstItem = Object.assign(originalFirstItem);
    firstItem.isAuthenticated = !!isAuthenticated;
    firstItem.preauthorizedResources = preauthorizedResources;
    firstItem.isSeriesPromo = isSeriesPromo;
    firstItem.collectionType = collectionType;
    const processedItem = featuredVideoProcessor({
      breakpoint,
      categoryType,
      context: COLLECTION_HERO_IMAGE,
      item: firstItem,
    });
    const videos = !isFirst ? items.member : items.member.slice(1);
    const { name, isLive, description } = processedItem;
    const featuredTitle = headline || name;
    const featuredTitleImage = _.get(images, 'header.raw');
    const slideClassName = classNames(
      Style.slide,
      Style.defaultPanel,
      idx === 0 ? Style.first : null,
      activeSlide === idx ? Style.active : null,
      activeSlide === idx && !play ? Style.inactive : null,
    );
    const headerContainerClass = isFirst ? Style.homeSlideHeaderContainer : null;
    let videoItems = videos.map(v => {
      if (!v) return null;
      const data = { ...v };
      data.isAuthenticated = !!isAuthenticated;
      data.preauthorizedResources = preauthorizedResources;
      data.isSeriesPromo = isSeriesPromo;
      data.showTileMetadataOnHover = showTileMetadataOnHover;
      return data;
    });
    videoItems = _.filter(videoItems, v => v);
    const onSelection = ({ itemIndex }) => {
      _.set(window, 'context.segment.home.sourceName', featuredTitle);
      const selectedItem = itemIndex !== null ? itemIndex + 1 : 0;
      const data = {
        title: featuredTitle,
        collectionType,
        items,
        selectedItem,
      };
      this.setRecommendationIdOnClick(items, selectedItem);
      setTealiumSourceCollectionGlobal(data);
    };
    const hideVideoItems = idx === 0 || _.isEmpty(videoItems);
    const collectionInfo = {
      headline,
      collectionType,
      categoryType,
      panelId,
      totalItems,
      totalCollections: this.pageCollectionLength || _.get(panels, 'totalItems'),
      uID: firstItem.uID,
    };
    const onPrimaryButtonClick = autoplayEnabled()
      ? e => {
          e.preventDefault();
          const url = e.target.href;
          if (globalVideoStartedPlayback) {
            this.updatePersistGlobalVideoAfterUmount(true, url);
          } else {
            const source = PAGE_COLLECTION;
            removeGlobalVideoPlayer({ source });
            router.push(url);
          }
        }
      : null;
    const header = (
      <HomeSlideHeaderComp
        accessToken={accessToken}
        allowInfoToggle={allowInfoToggle}
        breakpoint={breakpoint}
        callCollectionImpressionEvent={this.callCollectionImpressionEvent}
        collectionInfo={collectionInfo}
        coordinates={coordinates}
        description={description}
        disableSingleVideoHeroRender={globalVideoStartedPlayback && !streamExit}
        streamExit={streamExit}
        disableVideoRender={forceKeyartForShowcase}
        foxAwesomeLayout
        hasSingleSlide
        idx={idx}
        isFirst={isFirst}
        isLive={!!isLive}
        item={processedItem}
        load={load}
        onPrimaryButtonClick={onPrimaryButtonClick}
        onSelection={onSelection}
        onTitleClick={onSelection}
        onWatch={() => onSelection({ itemIndex: null })}
        overlay={overlay}
        play={!overlay}
        removeVideoHero={removeVideoHero}
        router={router}
        saveLiveRestart={this.handleSaveLiveRestart}
        saveLiveVideo={saveLiveVideo}
        setCoordinates={setCoordinates}
        setOverlay={setOverlay}
        setSuggestedChannel={setSuggestedChannel}
        setVideoHero={setVideoHero}
        showLiveButtons={showLiveButtons}
        smallCollectionHeader={smallCollectionHeader}
        title={featuredTitle}
        titleImage={featuredTitleImage}
        toggleVideoModal={this.toggleVideoModal}
        useSeriesLogo={useSeriesLogo}
        videoIsLive={videoIsLive}
      />
    );
    return (
      <div key={`videoPanel-${panelId}-${idx}`} id={panelId} className={slideClassName}>
        <Element className={headerContainerClass} name={`${ALL_COLLECTIONS_SCROLL_PREFIX}${idx}`}>
          {this.renderHeroImage(idx, 0, isFirst)}
          <Waypoint
            onEnter={() => {
              this.handleSlideChangeTop(idx, true);
              optimizelyUserAttributeEvents().collectionItem(collectionName);
              this.handleWaypointEntryAnalytics({
                anonymousId,
                featuredTitle,
                headline,
                idx,
                panel,
                panels,
              });
            }}
            onLeave={() => this.handleSlideChangeTop(idx, false)}
            topOffset="250px"
            bottomOffset="5%"
          >
            {idx === 0 ? <div className={Style.slideContainer}>{header}</div> : null}
          </Waypoint>
          <Waypoint
            onEnter={() => {
              this.handleSlideChangeBottom(idx, true);
              // Update visible elements
              const currentElements = visibleCollections;
              // Do not include showcase item or non rendered collections
              if (idx === 0 || hideVideoItems) return null;
              const currentCollection = _.get(currentElements, headline, false);
              if (currentCollection) {
                currentCollection.active = true;
                return updateVisibleElements(currentElements);
              }
              const slideCollectionItems = _.get(items, 'member');
              const currentVisibleSlideItems = slideCollectionItems.slice(0, carouselLimit);
              _.forEach(currentVisibleSlideItems, (item, index) => {
                const slideItem = item;
                slideItem.slideIndex = index;
              });
              const collectionLength = _.get(panel, 'items.totalItems');
              const endRangeValue =
                collectionLength < carouselLimit ? collectionLength : carouselLimit;
              const verticalPosition = getCollectionIndex(collectionOrder, panelId);
              const newItem = {
                headline,
                collectionType,
                totalItems,
                items: currentVisibleSlideItems,
                active: true,
                verticalPosition,
                slideRange: [0, endRangeValue - 1],
              };
              currentElements[headline] = newItem;
              return updateVisibleElements(currentElements);
            }}
            onLeave={() => {
              this.handleSlideChangeBottom(idx, false);
              // Update visible elements
              const currentElements = visibleCollections;
              const currentItem = _.get(currentElements, headline, false);
              if (currentItem) currentItem.active = false;
              updateVisibleElements(currentElements);
            }}
            topOffset="20%"
            bottomOffset="20%"
          >
            {hideVideoItems ? null : (
              <div>
                {this.renderTileCarousel({
                  idx,
                  videoItems,
                  headline: featuredTitle,
                  featuredTitleImage,
                  isFirst,
                  collectionCTA,
                  panel,
                  onSelection,
                })}
              </div>
            )}
          </Waypoint>
        </Element>
      </div>
    );
  }

  renderPanelHeroV2({ panel, idx, isFirst }) {
    const {
      accessToken,
      breakpoint,
      bookmarks,
      coordinates,
      forceKeyartForShowcase,
      globalVideoStartedPlayback,
      hasAccountOrProvider,
      isAuthenticated,
      isFreemium,
      overlay,
      panels,
      preauthorizedResources,
      profileId,
      removeGlobalVideoPlayer,
      removeVideoHero,
      router,
      saveLiveVideo,
      setCoordinates,
      setFreemiumModalVisibility,
      setOverlay,
      setSuggestedChannel,
      setVideoHero,
      streamExit,
      videoIsLive,
    } = this.props;
    const { activeSlide, play, load } = this.state;
    const heroCarouselProps = {
      accessToken,
      activeSlide,
      breakpoint,
      bookmarks,
      callCollectionImpressionEvent: this.callCollectionImpressionEvent,
      coordinates,
      forceKeyartForShowcase,
      globalVideoStartedPlayback,
      handleSaveLiveRestart: this.handleSaveLiveRestart,
      handleSlideChangeTop: this.handleSlideChangeTop,
      idx,
      isAuthenticated,
      isFirst,
      load,
      overlay,
      overridePlayButtonClick: setFreemiumModalVisibility,
      overridePlayButtonLink: isFreemium && !hasAccountOrProvider,
      panel,
      panels,
      play,
      preauthorizedResources,
      profileId,
      removeGlobalVideoPlayer,
      removeVideoHero,
      renderHeroImage: this.renderHeroImage,
      router,
      saveLiveVideo,
      setCoordinates,
      setOverlay,
      setRecommendationIdOnClick: this.setRecommendationIdOnClick,
      setSuggestedChannel,
      setVideoHero,
      streamExit,
      updatePersistGlobalVideoAfterUmount: this.updatePersistGlobalVideoAfterUmount,
      videoIsLive,
    };

    return (
      <>
        <HeroCarousel {...heroCarouselProps} />
        <Waypoint
          onEnter={() => {
            if (!this.viewedCollections.has(idx)) {
              this.viewedCollections.set(idx, {
                contentUids: getSegmentContentUidString(panel),
                id: panel.id,
                idx,
              });
            }
          }}
        />
      </>
    );
  }

  defaultPanelRendererV2({ panel, idx, isFirst }) {
    const {
      anonymousId,
      breakpoint,
      collectionOrder,
      isAuthenticated,
      panels,
      preauthorizedResources,
      updateVisibleElements,
      visibleCollections,
    } = this.props;
    const { activeSlide, play } = this.state;
    const { carouselLimit, showTileMetadataOnHover } = BREAKPOINTS[breakpoint];
    const { id: panelId, headline, images, items, collectionCTA, collectionType } = panel;
    if (!items) return null;
    const totalItems = _.get(items, 'totalItems');
    let originalFirstItem = _.get(items, 'member.0');
    if (!originalFirstItem) return null;
    if (originalFirstItem.items) {
      originalFirstItem = _.get(originalFirstItem, 'items.member.0', originalFirstItem);
    }
    const isSeriesPromo = collectionType === 'seriespromo';
    const firstItem = Object.assign(originalFirstItem);
    firstItem.isAuthenticated = !!isAuthenticated;
    firstItem.preauthorizedResources = preauthorizedResources;
    firstItem.isSeriesPromo = isSeriesPromo;
    const processedItem = featuredVideoProcessor({
      breakpoint,
      context: COLLECTION_HERO_IMAGE,
      item: firstItem,
    });
    const videos = !isFirst ? items.member : items.member.slice(1);
    const { name } = processedItem;
    const featuredTitle = headline || name;
    const featuredTitleImage = _.get(images, 'header.raw');
    const slideClassName = classNames(
      Style.slide,
      Style.defaultPanel,
      idx === 0 ? Style.first : null,
      activeSlide === idx ? Style.active : null,
      activeSlide === idx && !play ? Style.inactive : null,
    );

    let headerContainerClass;

    if (isFirst) {
      headerContainerClass = classNames(Style.homeSlideHeaderContainer, Style.firstHeaderContainer);
    }

    let videoItems = videos.map(v => {
      if (!v) return null;
      const data = { ...v };
      data.isAuthenticated = !!isAuthenticated;
      data.preauthorizedResources = preauthorizedResources;
      data.isSeriesPromo = isSeriesPromo;
      data.showTileMetadataOnHover = showTileMetadataOnHover;
      return data;
    });
    videoItems = _.filter(videoItems, v => v);
    const onSelection = ({ itemIndex }) => {
      _.set(window, 'context.segment.home.sourceName', featuredTitle);
      const selectedItem = itemIndex !== null ? itemIndex + 1 : 0;
      const data = {
        title: featuredTitle,
        collectionType,
        items,
        selectedItem,
      };
      this.setRecommendationIdOnClick(items, selectedItem);
      setTealiumSourceCollectionGlobal(data);
    };
    const hideVideoItems = _.isEmpty(videoItems);
    return (
      <div key={`videoPanel-${panelId}-${idx}`} id={panelId} className={slideClassName}>
        <Element className={headerContainerClass} name={`${ALL_COLLECTIONS_SCROLL_PREFIX}${idx}`}>
          {this.renderHeroImage(idx, 0, isFirst)}
          <Waypoint
            onEnter={() => {
              this.handleWaypointEntryAnalytics({
                anonymousId,
                featuredTitle,
                headline,
                idx,
                panel,
                panels,
              });

              this.handleSlideChangeBottom(idx, true);
              // Update visible elements
              const currentElements = visibleCollections;
              // Do not include showcase item or non rendered collections
              if (idx === 0 || hideVideoItems) return null;
              const currentCollection = _.get(currentElements, headline, false);
              if (currentCollection) {
                currentCollection.active = true;
                return updateVisibleElements(currentElements);
              }
              const slideCollectionItems = _.get(items, 'member');
              const currentVisibleSlideItems = slideCollectionItems.slice(0, carouselLimit);
              _.forEach(currentVisibleSlideItems, (item, index) => {
                const slideItem = item;
                slideItem.slideIndex = index;
              });
              const collectionLength = _.get(panel, 'items.totalItems');
              const endRangeValue =
                collectionLength < carouselLimit ? collectionLength : carouselLimit;
              const verticalPosition = getCollectionIndex(collectionOrder, panelId);
              const newItem = {
                headline,
                collectionType,
                totalItems,
                items: currentVisibleSlideItems,
                active: true,
                verticalPosition,
                slideRange: [0, endRangeValue - 1],
              };
              currentElements[headline] = newItem;
              return updateVisibleElements(currentElements);
            }}
            onLeave={() => {
              this.handleSlideChangeBottom(idx, false);
              // Update visible elements
              const currentElements = visibleCollections;
              const currentItem = _.get(currentElements, headline, false);
              if (currentItem) currentItem.active = false;
              updateVisibleElements(currentElements);
            }}
            topOffset="20%"
            bottomOffset="5%"
          >
            {hideVideoItems ? null : (
              <div>
                {this.renderTileCarousel({
                  idx,
                  videoItems,
                  headline: featuredTitle,
                  featuredTitleImage,
                  isFirst,
                  collectionCTA,
                  panel,
                  onSelection,
                })}
              </div>
            )}
          </Waypoint>
        </Element>
      </div>
    );
  }

  fetchCollectionData(opts) {
    const shouldFetch = opts?.shouldFetch;
    const {
      accessToken,
      account,
      deviceId,
      fetchCollections,
      panelRenderCount,
      route,
    } = this.props;
    const path = route?.screenUrl;
    const screenName = route?.path;
    if (!panelRenderCount || shouldFetch) {
      fetchCollections({
        accessToken,
        account,
        deviceId,
        panelsToPrefetch: 3,
        path,
        screenName,
      });
    }
  }

  // sets timeout to refresh specific collections
  fetchCollectionInterval() {
    const { clearInterval, panels, setInterval, resetPanelLoaded } = this.props;
    const { collectionInterval } = this.state;
    let nextUpdateIn = _.get(panels, 'member.0.validFor', FETCH_COLLECTION_DEFAULT);
    if (nextUpdateIn < 0) nextUpdateIn = FETCH_COLLECTION_DEFAULT;

    if (collectionInterval) clearInterval(collectionInterval);
    const newCollectionInterval = setInterval(() => {
      resetPanelLoaded();
      this.refreshCollection();
    }, nextUpdateIn);
    this.setState({ collectionInterval: newCollectionInterval });
  }

  genrePanelRenderer({ panel, idx, isFirst }) {
    const { activeSlide, play } = this.state;
    const { id: panelId, headline, items } = panel;
    const videoItems = _.get(items, 'member', []);
    if (!videoItems || !videoItems.length) return null;
    const featuredTitle = headline || '';
    const slideClassName = classNames(
      Style.slide,
      Style.defaultPanel,
      idx === 0 ? Style.first : null,
      activeSlide === idx ? Style.active : null,
      activeSlide === idx && !play ? Style.inactive : null,
    );
    const genreCarousel = this.renderTileCarousel({
      headline: featuredTitle,
      isFirst,
      isGenreCollection: true,
      videoItems,
      panel,
    });

    return (
      <div key={`genrePanel-${panelId}-${idx}`} id={panelId} className={slideClassName}>
        <Element name={`${ALL_COLLECTIONS_SCROLL_PREFIX}${idx}`}>
          <Waypoint
            onEnter={() => {
              this.handleSlideChangeBottom(idx, true);
              if (!this.viewedCollections.has(idx)) {
                this.viewedCollections.set(idx, {
                  contentUids: getSegmentContentUidString(panel),
                  id: panel.id,
                  idx,
                });
              }
            }}
            onLeave={() => this.handleSlideChangeBottom(idx, false)}
            topOffset="20%"
            bottomOffset="20%"
          >
            <div>{genreCarousel}</div>
          </Waypoint>
        </Element>
      </div>
    );
  }

  getDefaultVideoContainerProps = () => {
    const {
      accessToken,
      account,
      adblock,
      anonymousId,
      anonymousLogin,
      authSuccess,
      blackoutConfig,
      blackoutDefinitions,
      breakpoint,
      deviceId,
      isStatic,
      mvpdData,
      onAuthCheckComplete,
      openSignIn,
      openSignUp,
      preauthorizedResources,
      profileId,
      provider,
      renderAuthContainer,
      setAccountCloseIgnoreRedirect,
      setAuthorizationToken,
      setBlockMVPDIncomplete,
      setInterval,
      setIsAuthenticated,
      setIsPlayerLoaded,
      setMVPDToAppState,
      setOverlay,
      setProvider,
      toggleMvpdAuthOverlay,
      triggerAuthCheck,
    } = this.props;

    return {
      accessToken,
      account,
      adblock,
      anonymousId,
      anonymousLogin,
      authSuccess,
      blackoutConfig,
      blackoutDefinitions,
      breakpoint,
      deviceId,
      isStatic,
      mvpdData,
      onAuthCheckComplete,
      openSignIn,
      openSignUp,
      preauthorizedResources,
      profileId,
      provider,
      renderAuthContainer,
      setAccountCloseIgnoreRedirect,
      setAuthorizationToken,
      setBlockMVPDIncomplete,
      setInterval,
      setIsAuthenticated,
      setIsPlayerLoaded,
      setMVPDToAppState,
      setOverlay,
      setProvider,
      toggleMvpdAuthOverlay,
      triggerAuthCheck,
    };
  };

  renderVideoBanner({ panel, idx }) {
    const {
      accessToken,
      account,
      anonymousAccount,
      anonymousId,
      anonymousLogin,
      authSuccess,
      breakpoint,
      deviceId,
      panels,
      preauthorizedResources,
      onAuthCheckComplete,
      mvpdData,
      toggleMvpdAuthOverlay,
    } = this.props;
    if (canDisplayUpsell(preauthorizedResources)) return null;
    const { activeSlide, play, userViewedPlayerBanner } = this.state;
    const defaultVideoContainerProps = this.getDefaultVideoContainerProps();
    const mvpd = _.get(mvpdData, 'mvpd', '');
    const panelId = _.get(panel, 'id');
    const slideClassName = classNames(
      Style.slide,
      Style.defaultPanel,
      idx === 0 ? Style.first : null,
      activeSlide === idx ? Style.active : null,
      activeSlide === idx && !play ? Style.inactive : null,
    );
    const id = `videoBanner-${panelId}-${idx}`;
    const handleAuthCheckComplete = opts => {
      onAuthCheckComplete(opts);
      if (userViewedPlayerBanner) {
        this.scrollToCollection(panels, panelId);
      }
    };
    const setUserViewedPlayerBanner = value => {
      const valueChanged = value !== userViewedPlayerBanner;
      if (valueChanged) this.setState({ userViewedPlayerBanner: value });
    };

    return (
      <div id={id} className={slideClassName}>
        <Element name={`${ALL_COLLECTIONS_SCROLL_PREFIX}${idx}`}>
          <VideoBanner
            accessToken={accessToken}
            account={account}
            anonymousAccount={anonymousAccount}
            anonymousId={anonymousId}
            anonymousLogin={anonymousLogin}
            authSuccess={authSuccess}
            breakpoint={breakpoint}
            collectionCount={getCollectionCount(panels, this.hiddenPanels)}
            defaultVideoContainerProps={defaultVideoContainerProps}
            deviceId={deviceId}
            id={id}
            mvpd={mvpd}
            onAuthCheckComplete={handleAuthCheckComplete}
            panel={panel}
            preauthorizedResources={preauthorizedResources}
            setUserViewedPlayerBanner={setUserViewedPlayerBanner}
            toggleMvpdAuthOverlay={toggleMvpdAuthOverlay}
            userViewedPlayerBanner={userViewedPlayerBanner}
            verticalPosition={idx + 1}
          />
        </Element>
      </div>
    );
  }

  renderMarketingVideoBanner({ panel, idx }) {
    const { breakpoint, panels } = this.props;
    const { activeSlide, play } = this.state;
    const panelId = _.get(panel, 'id');
    const slideClassName = classNames(
      Style.slide,
      Style.defaultPanel,
      idx === 0 ? Style.first : null,
      activeSlide === idx ? Style.active : null,
      activeSlide === idx && !play ? Style.inactive : null,
    );
    const id = `marketingVideoBanner-${panelId}-${idx}`;
    const adjacentCollectionAbove = getAdjacentCollectionAbove(panels, idx);
    const isMobile = isMobileBreakpoint(breakpoint) || breakpoint === SITE_PLATFORM_TABLET;
    const bannerDimensions = getSegmentBannerDimensions('marketing video banner', isMobile);
    const bannerProps = {
      ...getMarketingVideoBanner(panel),
      breakpoint,
      adjacentCollectionAbove,
      bannerDimensions,
    };
    return (
      <div id={id} className={slideClassName}>
        <Element name={`${ALL_COLLECTIONS_SCROLL_PREFIX}${idx}`}>
          <MarketingBanner {...bannerProps} />
        </Element>
      </div>
    );
  }

  handleCountdownEnd = () => {
    this.setState({ shouldRenderCountdown: false });
  };

  renderCountdownBanner = ({ panel, idx }) => {
    if (!countdownBannerEnabled()) return null;

    const { breakpoint } = this.props;
    const panelItem = panel?.items?.member?.[0];
    const imagePath = panelItem?.images;
    const panelId = panel?.id;
    const countdownTo = panelItem?.countdownTo;
    const timeLeft = Date.parse(stringToDate(countdownTo)) - Date.parse(now());

    if (timeLeft <= 0) return null;

    const url = panelItem?.url;
    const headline = panel?.headline;
    const id = `countdownBanner-${panelId}-${idx}`;
    const mobileCountdownImage = imagePath?.['mobile-promo'];
    const desktopCountdownImage = imagePath?.['desktop-promo'];
    const backgroundImage = isMobileBreakpoint(breakpoint)
      ? mobileCountdownImage
      : desktopCountdownImage;

    const dynamicBackgroundImage = getDynamicImage({
      breakpoint,
      url: backgroundImage,
      context: COUNTDOWN_BANNER_IMAGE,
    });

    const slideClassName = classNames(
      Style.countdownBanner,
      Style.slide,
      Style.defaultPanel,
      idx === 0 && Style.first,
    );

    return (
      <div id={id} className={slideClassName}>
        <Element name={`${ALL_COLLECTIONS_SCROLL_PREFIX}${idx}`}>
          <CountdownBanner
            bgImage={dynamicBackgroundImage}
            countdownTo={countdownTo}
            handleCountdownEnd={this.handleCountdownEnd}
            headline={headline}
            url={url}
          />
        </Element>
      </div>
    );
  };

  renderBreadcrumb = () => {
    const { route } = this.props;

    return (
      <div className={Style.breadcrumb}>
        <BreadcrumbsComponent
          data={breadcrumbsCollectionParser(route)}
          customStyle={Style.breadcrumbs}
        />
      </div>
    );
  };

  renderAnonymousView() {
    const { hasAccountOrProvider } = this.props;
    return !hasAccountOrProvider && <FloatingStartFreeTrial theme={Style} />;
  }

  renderContent() {
    if (this.isLoading()) return this.renderLoading();

    const { location, params, panels } = this.props;
    const { newRelicStart } = this.state;
    const pathName = _.get(location, 'pathname');
    const newRelicPageName = getNewRelicPageName(pathName, params);
    if (newRelicStart) {
      logEvent(`on${newRelicPageName}ScreenFinished`);
      this.setState({ newRelicStart: false });
    }
    return (
      <IdleTimer onIdle={this.onIdle} timeout={5000}>
        {this.renderPanels()}
        <Waypoint
          topOffset="100px"
          onEnter={() => {
            const { numPanelsRendered } = this.state;
            if (numPanelsRendered < panels?.member.length) {
              this.setState({ numPanelsRendered: numPanelsRendered + 3 });
            }
          }}
        />
        {this.renderVideoModal()}
        {this.renderBreadcrumb()}
      </IdleTimer>
    );
  }

  renderHeroImage = (index, memberIndex = 0, isFirst = false) => {
    const { panels, breakpoint } = this.props;
    const hero = _.get(panels, `member.${index}.items.member.${memberIndex}`);
    const isPromo = _.get(hero, 'promoType');
    const fadeClasses = [Style.fade, Style.redesignFade];
    if (!panels || panels.length === 0 || !isFirst) return null;
    const heroImage = this.getHeroImage(hero, isPromo);
    const isCountdown = isShowcaseCountdown(hero);
    const heroImageUrl = getDynamicImage({
      breakpoint,
      url: heroImage,
      context: COLLECTION_HERO_IMAGE,
      unoptimized: isCountdown,
    });
    if (!heroImage) return null;
    return (
      <div className={classNames(Style.heroImageContainer, Style.heroPromo)}>
        <img className={Style.heroImagePoster} src={heroImageUrl} alt="heroImage" />
        <div className={classNames(fadeClasses)} />
      </div>
    );
  };

  renderLargePromo(boundProps, item) {
    const { idx, isFirst } = boundProps;
    const { streamExit } = this.props;
    const { activeSlide, play } = this.state;
    const id = _.get(item, 'id');
    const headline = _.get(item, 'headline');
    const altHeadline = _.get(item, 'alternativeHeadline');
    const description = _.get(item, 'description');
    const subDescription = _.get(item, 'subDescription');
    const displayBrand = getDisplayBrand(item);
    const networkLogoUrl = getNetworkLogoUrl(displayBrand);
    const url = _.get(item, 'url');
    const buttonText = _.get(item, 'ctaText');
    const slideClassName = classNames(
      Style.slide,
      Style.defaultPanel,
      activeSlide === idx ? Style.active : null,
      activeSlide === idx && !play ? Style.inactive : null,
    );

    return (
      <div key={`large-promo-${id}-${idx}`} className={slideClassName}>
        <Element name={`${ALL_COLLECTIONS_SCROLL_PREFIX}${idx}`}>
          {this.renderHeroImage(idx, 0, isFirst)}
          <Waypoint
            onEnter={() => {
              this.handleSlideChangeTop(idx, true);
            }}
            onLeave={() => this.handleSlideChangeTop(idx, false)}
            topOffset="250px"
          >
            <div>
              <HomeSlidePromoComp
                id={id}
                headline={headline}
                altHeadline={altHeadline}
                description={description}
                subDescription={subDescription}
                networkLogoUrl={networkLogoUrl}
                streamExit={streamExit}
                network={displayBrand}
                url={url}
                buttonText={buttonText}
              />
            </div>
          </Waypoint>
        </Element>
      </div>
    );
  }

  renderLoading() {
    const { breakpoint } = this.props;
    return (
      <>
        <div
          className={classNames(Style.loaderWrapper, {
            [Style.isNation]: true,
          })}
        >
          <Loader collections />
          <div className={Style.heroLoaderPlaceholder}>
            <div className={Style.heroLoaderTitle} />
            <div className={Style.heroLoaderSubtitle} />
            <div className={Style.heroLoaderDescription} />
            <div className={Style.heroLoaderBottomDescription} />
            <div className={Style.heroLoaderButton} />
          </div>
        </div>
        <div className={Style.separator} />
        <LoaderCarousel breakpoint={breakpoint} isPoster />
        <LoaderCarousel breakpoint={breakpoint} />
      </>
    );
  }

  renderStrikeBanner(index) {
    if (!strikeBannerEnabled()) return null;
    const { panels, location } = this.props;

    const pathName = _.get(location, 'pathname', '');
    const isEntertainmentPage = pathName.indexOf('entertainment') !== -1;
    const isHomePage = pathName === '/';

    if (!isHomePage && !isEntertainmentPage) return null;

    const member = _.get(panels, 'member', []);
    const carouselIndexes = member.reduce((acc, panel, idx) => {
      const panelType = _.get(panel, 'panelType', null);
      if (panelType === PANEL_TYPE_VIDEOS || panelType === PANEL_TYPE_SHOWS) {
        acc.push(idx);
      }
      return acc;
    }, []);

    const firstPlacementAterNthCarousel = 3;
    const firstPlacementIndex = _.get(carouselIndexes, firstPlacementAterNthCarousel, null);
    const lastIndex = carouselIndexes.slice(-1).pop();
    const lastPlacementIndex = lastIndex !== firstPlacementAterNthCarousel ? lastIndex : null;

    const placement = [firstPlacementIndex, lastPlacementIndex].indexOf(index);
    const bannerIndex = placement !== -1 ? placement + 1 : null;
    if (!bannerIndex) return null;
    const pageType = isEntertainmentPage ? STRIKE_PAGE_TYPE_SECTION_FRONT : STRIKE_PAGE_TYPE_HOME;
    return <StrikeBanner index={bannerIndex} pageType={pageType} />;
  }

  renderEngagementBanner(index) {
    const { location } = this.props;
    let zone;
    const pathName = _.get(location, 'pathname', '');
    const isShowsPage = pathName.indexOf('shows') !== -1;
    const isPersonalitiesPage = pathName.indexOf('personalities') !== -1;
    const isListenPage = pathName.indexOf('listen') !== -1;
    const isHomePage = pathName.indexOf('featured') !== -1;

    const topRowIndex = 1;
    const secondRowIndex = 2;
    const thirdRowIndex = 3;
    const fourthRowIndex = 4;

    switch (index) {
      case topRowIndex:
        if (isHomePage) {
          zone = FEATURED_BANNER_TOP;
        } else if (isPersonalitiesPage) {
          zone = PERSONALITIES_BANNER_TOP;
        } else if (isShowsPage) {
          zone = SHOWS_BANNER_TOP;
        } else if (isListenPage) {
          zone = LISTEN_BANNER_TOP;
        }
        break;
      case secondRowIndex:
        if (isHomePage) {
          zone = FEATURED_BANNER_2ND;
        }
        break;
      case thirdRowIndex:
        if (isHomePage) {
          zone = FEATURED_BANNER_3RD;
        }
        break;
      case fourthRowIndex:
        if (isHomePage) {
          zone = FEATURED_BANNER_4TH;
        }
        break;
      default:
        break;
    }
    if (this.brazeContent) {
      const content = this.brazeContent;
      return BrazeContentRender(zone, content);
    }
    return zone ? <RedFastBanner zone={zone} /> : null;
  }

  renderPanels() {
    const {
      accessToken,
      authSuccess,
      breakpoint,
      coordinates,
      deviceId,
      favoritesManager,
      globalVideoStartedPlayback,
      incrementPanelRenderCount,
      useShowcaseFallback,
      panels,
      location,
    } = this.props;
    const {
      shouldFetchMore,
      showcase,
      userViewedPlayerBanner,
      renderedPanels,
      numPanelsRendered,
      shouldRenderCountdown,
    } = this.state;
    const showcaseId = _.get(showcase, 'id');
    let isFirst = true;
    if (!panels) return null;
    const favorites = _.get(favoritesManager, 'favorites');
    let items = JSON.parse(JSON.stringify(panels.member));
    if (showcaseId) {
      const itemsWithoutShowcase = _.filter(items, obj => obj && obj.id !== showcaseId);
      const itemsWithShowcaseFirst = [showcase, ...itemsWithoutShowcase];
      items = itemsWithShowcaseFirst;
    }
    const path = _.get(location, 'pathname');
    const fakeCollecitonData = getOptimizelyFakeCollectionData();
    if (MarketingCollectionEnabled || (fakeCollecitonData.renderFakeCollection && path === '/')) {
      if (fakeCollecitonData.renderFakeCollection)
        NationCollection.headline = fakeCollecitonData.collectionTitle;
      items.splice(2, 0, NationCollection);
    }
    if (!this.pageCollectionLength)
      this.pageCollectionLength = getCollectionCount(panels, this.hiddenPanels);
    return items.map((panel, index) => {
      if (!panel) return null;

      const { showcase } = this.state;
      const showcaseId = _.get(showcase, 'id');
      const panelId = _.get(panel, 'id');
      const idx = index;
      const member = _.get(panel, 'items.member', []);
      const isFirstVal = isFirst;
      if (isFirst) isFirst = false;

      if (!shouldRenderCountdown && panel?.collectionType === 'countdown') {
        return null;
      }

      const panelProps = {
        accessToken,
        breakpoint,
        calculateValidFor: calculateNextRefreshForPanel,
        'data-test': 'home-content',
        deviceId,
        headerGenerator: helperGetApiHeaders,
        panelData: panel,
        panelId,
        pageType: 'upNext',
        propsToWatch: {
          authSuccess,
          coordinates,
          favorites,
          globalVideoStartedPlayback,
          member,
          shouldFetchMore,
          showcaseId,
          useShowcaseFallback,
          userViewedPlayerBanner,
        },
        routeGenerator: helperConvertApiRoute,
        shouldFetchMore,
      };
      if (index > numPanelsRendered) return null;
      return (
        <>
          <Panel
            key={`home-panel-${panelId}`}
            {...panelProps}
            renderer={data => {
              if (!renderedPanels[panelId] && data?.panelType) {
                this.setState(prevState => ({
                  renderedPanels: {
                    ...prevState.renderedPanels,
                    [panelId]: true,
                  },
                }));
                updateSegmentBannerData(_.get(panels, 'member', []));
                incrementPanelRenderCount();
              }
              return this.selectPanelRenderer({ idx, isFirst: isFirstVal }, data);
            }}
          />
          {this.renderStrikeBanner(idx)}
          {this.renderEngagementBanner(idx)}
        </>
      );
    });
  }

  renderSmallPromo(boundProps, item) {
    const { idx } = boundProps;
    const { breakpoint, panels } = this.props;
    const adjacentCollectionAbove = getAdjacentCollectionAbove(panels, idx);
    const bannerType = getSegmentBannerType(item);
    const isMobile = isMobileBreakpoint(breakpoint) || breakpoint === SITE_PLATFORM_TABLET;
    const bannerDimensions = getSegmentBannerDimensions(bannerType, isMobile);
    const id = _.get(item, 'id');
    const headlineText = _.get(item, 'headline');
    const name = _.get(item, 'name', '');
    const displayBrand = getDisplayBrand(item);
    const networkLogoUrl = getNetworkLogoUrl(displayBrand);
    const url = _.get(item, 'url');
    const buttonText = _.get(item, 'ctaText');
    const formattedUrl = formatDirectUrl(url);
    const onlyRenderImage = !buttonText;
    const imageType = _.get(BREAKPOINTS[breakpoint], 'smallPromoImage');
    const imageUrl = _.get(item, imageType);
    // Promo Objects missing AltText CPEWEB-1972
    const imageTag = renderImage({
      alt: '',
      breakpoint,
      className: smallPromoStyle.background,
      imageType: SMALL_PROMO_IMAGE,
      src: imageUrl,
    });
    const { target, rel } = getUrlTarget(formattedUrl);
    const onClickSmallPromo = () => {
      handleAnalytics({
        event: Events.BANNER_NOTIFICATION_ACTION,
        payload: {
          page_message_title: _.get(item, 'name'),
          page_message_text: _.get(item, 'headline'),
          page_message_type: _.get(item, 'name'),
          page_action_type: _.get(item, 'name'),
        },
      });

      const bannerClickedProps = _.pickBy({
        page_item_dimension: bannerDimensions,
        page_item_type: bannerType,
        page_item_title: headlineText || name,
        page_item_subtitle: '',
        page_button_text: '',
        page_action_location: 'whole banner',
        page_collection_title: adjacentCollectionAbove,
        page_item_state: 'static image',
      });
      handleAnalytics({
        event: Events.BANNER_CLICKED,
        payload: { ...bannerClickedProps },
      });
    };
    let networkComponent = networkLogoUrl ? (
      <img className={smallPromoStyle.networkLogo} src={networkLogoUrl} alt={displayBrand} />
    ) : null;
    let button = (
      <Link to={formattedUrl} target={target} rel={rel} className={smallPromoStyle.cta}>
        {buttonText}
      </Link>
    );
    let headline = <div className={smallPromoStyle.headline}>{headlineText}</div>;
    let contents = (
      <div className={smallPromoStyle.container}>
        {networkComponent}
        {headline}
        {button}
      </div>
    );

    if (onlyRenderImage) {
      networkComponent = null;
      button = null;
      headline = null;
      contents = null;
    }

    let outerContainerChildren = (
      <div>
        {imageTag}
        {contents}
      </div>
    );

    if (onlyRenderImage) {
      outerContainerChildren = (
        <Link
          to={formattedUrl}
          target={target}
          rel={rel}
          aria-label={_.get(item, 'name')}
          onClick={onClickSmallPromo}
        >
          {outerContainerChildren}
        </Link>
      );
    }

    return (
      <div
        key={`small-promo-${id}-${idx}`}
        className={classNames(
          Style.slide,
          Style.defaultPanel,
          Style.active,
          smallPromoStyle.slideSmallPromo,
          Style.promoBanner,
        )}
      >
        <Element name={`${ALL_COLLECTIONS_SCROLL_PREFIX}${idx}`}>
          <Waypoint
            onEnter={() => this.handleSlideChangeTop(idx, true)}
            onLeave={() => this.handleSlideChangeTop(idx, false)}
            topOffset="250px"
          >
            <div className={smallPromoStyle.outerContainer}>{outerContainerChildren}</div>
          </Waypoint>
        </Element>
      </div>
    );
  }

  renderTileCarousel({
    idx,
    collectionCTA,
    videoItems,
    featuredTitleImage,
    isFirst,
    isGenreCollection,
    panel,
    onSelection,
  } = {}) {
    const {
      account,
      bookmarks,
      breakpoint,
      collectionOrder,
      favoritesManager,
      location: { pathname },
      panels,
      removeGlobalVideoPlayer,
      saveLiveVideo,
      disableScroll,
      visibleCollections,
      setSuggestedChannel,
      setFreemiumModalVisibility,
    } = this.props;

    const {
      addCarouselPlaceholders,
      allowScrollLock,
      carouselLimit,
      roundArrows,
      slidesToScroll,
      posterLimit,
      posterToScroll,
      descriptionLines,
      showCarouselArrows,
      useMobileUpcomingOverlay,
      useScrollableDiv,
    } = BREAKPOINTS[breakpoint];

    const headline = _.get(panel, 'headline');
    const totalCollections = _.get(panels, 'totalItems');
    const collectionType = _.get(panel, 'collectionType');
    const displayTemplate = _.get(panel, 'displayTemplate');
    const totalItems = _.get(panel, 'items.totalItems');
    const panelId = _.get(panel, 'id');
    const collectionName = getCollectionName(pathname);

    const tealiumTileClick = props => {
      const { item, idx: index } = props;
      const seriesName = _.get(item, 'seriesName');
      const name = _.get(item, 'name');
      const subtitle = _.get(homeCarouselVideoProcessor({ video: item }), 'subtitleText');
      this.callCollectionImpressionEvent();
      const cachedVerticalPosition = _.get(
        visibleCollections,
        `${headline}.verticalPosition`,
        null,
      );
      const verticalPosition =
        cachedVerticalPosition || getCollectionIndex(collectionOrder, panelId);
      getTealiumRedesignEvents({ account }).collectionItemSelect({
        account,
        state: 'static image',
        containerTitle: headline,
        verticalPosition,
        horizontalPosition: `${index + 1}`,
        title: seriesName || name,
        subtitle,
        cc: 'cc off',
        volume: 'volume off',
        collectionTitle: headline,
        collectionType,
        playlistLength: totalItems,
        collectionCount: totalCollections,
        item,
        visibleCollections,
      });
    };

    const onTileClick = props => {
      const { item, itemIdx } = props;
      const isLiveItem = isLive(_.get(item, '@type'));
      const isLiveNow = _.get(item, 'isLiveNow', false);
      const { id, callSign } = item;
      // Revisit: there's no way to identify bonus feeds right now, so we're using
      // this for all live sports feeds(?)
      if (isSportsContent(item) && isLiveItem) {
        if (isLiveItem && !isLiveNow) return;
        setSuggestedChannel({ network: callSign, programId: id });
        helperGoToRelativeUrl(helperGetLiveUrl({ callSign }));
      }
      if (autoplayEnabled()) {
        const source = PAGE_COLLECTION;
        removeGlobalVideoPlayer({ source });
      }
      if (!EpgEnabled && isLiveItem) saveLiveVideo(item);
      if (onSelection) onSelection({ itemIndex: itemIdx });
      tealiumTileClick(props);
    };

    const isMobile = isMobileBreakpoint(breakpoint);
    const isFeatured = displayTemplate === 'featured';
    const isLatestEpisodes = !isMobile && displayTemplate === 'latestEpisodes';
    const isPosters = isFeatured || isLatestEpisodes;
    const isLiveCollection = collectionType && collectionType.toLowerCase() === 'live';
    const panelType = _.get(panel, 'panelType');
    let additionalPosterLimit = 4;
    const currentBreakpoint = _.get(window, 'innerWidth');
    if (currentBreakpoint >= TABLET_LANDSCAPE_BREAKPOINT) additionalPosterLimit = 4;
    if (currentBreakpoint >= DESKTOP_BREAKPOINT) additionalPosterLimit = 5;
    if (currentBreakpoint >= XL_BREAKPOINT) additionalPosterLimit = 6;
    const currentPosterLimit = additionalPosterEnabled() ? additionalPosterLimit : posterLimit;
    const customPosterLimit =
      isLatestEpisodes &&
      (SITE_PLATFORM_WEB === breakpoint || SITE_PLATFORM_WEB_LARGE === breakpoint)
        ? 4
        : currentPosterLimit;
    const customPosterToScroll =
      isLatestEpisodes &&
      (SITE_PLATFORM_WEB === breakpoint || SITE_PLATFORM_WEB_LARGE === breakpoint)
        ? 4
        : posterToScroll;
    let itemsToScroll = isPosters ? customPosterToScroll : slidesToScroll;
    let itemsToShow = isPosters ? customPosterLimit : carouselLimit;
    if (liveTileCollectionV2Enabled() && isLiveCollection && SITE_PLATFORM_TABLET === breakpoint) {
      itemsToScroll = 2;
      itemsToShow = 2;
    }
    if (
      liveTileCollectionV2Enabled() &&
      isLiveCollection &&
      (SITE_PLATFORM_WEB === breakpoint || SITE_PLATFORM_WEB_LARGE === breakpoint)
    ) {
      itemsToScroll = 3;
      itemsToShow = 3;
    }
    const carouselProps = {
      addCarouselPlaceholders,
      allowScrollLock,
      collectionType,
      collectionCount: getCollectionCount(panels, this.hiddenPanels),
      playlistLength: _.get(panel, 'items.member.length', 0),
      collectionName,
      collectionVerticalPosition: getCollectionPosition(panels, idx, headline, this.hiddenPanels),
      beforeChange: this.updateVisibleSlides,
      breakpoint,
      descriptionLines,
      disableScroll,
      favoritesManager,
      featuredTitleImage,
      headline,
      isFirst,
      isHoverStateV2: true,
      isLiveTileV2: liveTileCollectionV2Enabled() && isLiveCollection,
      isInfinite: false,
      isPosters,
      items: addSeeMoreItem({ items: videoItems, collectionCTA, isFirst }),
      noPreview: isLatestEpisodes,
      onTileClick,
      overrideTheme: isLatestEpisodes ? LatestEpisodes : null,
      panel,
      panelIdx: idx,
      processor: item =>
        homeCarouselVideoProcessor({
          account,
          bookmarks,
          collectionType,
          displayTemplate,
          isHoverStateV2: true,
          isMobile,
          isPosters,
          panelType,
          video: item,
        }),
      renderImage: image =>
        renderImage({
          breakpoint,
          imageType: COLLECTION_THUMBNAIL_IMAGE,
          ...image,
        }),
      roundArrows,
      setFreemiumModalVisibility,
      shouldDisplayNetworkLogo: thumbnailNetworkLogoEnabled(),
      shouldInvertTitleOrder: item => isClip(item.videoType),
      showCarouselArrows,
      slidesToScroll: itemsToScroll,
      slidesToShow: itemsToShow,
      theme: isPosters ? CarouselPosterStyle : CarouselTheme,
      tileTheme: CarouselTileTheme,
      updateVisibleSlides: this.updateVisibleSlides,
      useScrollableDiv,
      subtitleLines: null,
    };

    if (isPosters && !isLatestEpisodes) {
      carouselProps.responsive = defaultPosterResponsiveness;
    }

    if (isGenreCollection) {
      carouselProps.processor = homeLinkTileCarouselProcessor;
      carouselProps.tileTheme = GenreTileTheme;
      carouselProps.isGenreCollection = true;
    }
    if (useMobileUpcomingOverlay) {
      carouselProps.upcomingOverlay = this.toggleUpcomingOverlay;
    }

    return (
      <div key="tile-carousel">
        <div
          className={classNames([
            carouselProps.tileTheme.container,
            additionalPosterEnabled() && carouselProps.tileTheme.additionalPoster,
          ])}
        >
          <Carousel {...carouselProps} data-test="web-carousel" />
        </div>
      </div>
    );
  }

  renderCollectionTileCarousel({
    idx,
    collectionCTA,
    videoItems,
    featuredTitleImage,
    isFirst,
    isGenreCollection,
    panel,
    onSelection,
  } = {}) {
    const {
      account,
      breakpoint,
      collectionOrder,
      favoritesManager,
      panels,
      removeGlobalVideoPlayer,
      saveLiveVideo,
      disableScroll,
      visibleCollections,
    } = this.props;
    const {
      addCarouselPlaceholders,
      allowScrollLock,
      carouselLimit,
      slidesToScroll,
      showCarouselArrows,
      showTileMetadataOnHover,
      useMobileUpcomingOverlay,
      useScrollableDiv,
    } = BREAKPOINTS[breakpoint];
    const headline = _.get(panel, 'headline');
    const totalCollections = _.get(panels, 'totalItems');
    const collectionType = _.get(panel, 'collectionType');
    const totalItems = _.get(panel, 'items.totalItems');
    const panelId = _.get(panel, 'id');
    const tealiumTileClick = props => {
      const { item, itemIndex: index } = props;
      const seriesName = _.get(item, 'seriesName');
      const name = _.get(item, 'name');
      const subtitle = _.get(homeCarouselVideoProcessor({ video: item }), 'subtitleText');
      this.callCollectionImpressionEvent();
      const cachedVerticalPosition = _.get(
        visibleCollections,
        `${headline}.verticalPosition`,
        null,
      );
      const verticalPosition =
        cachedVerticalPosition || getCollectionIndex(collectionOrder, panelId);
      getTealiumRedesignEvents({ account }).collectionItemSelect({
        account,
        state: 'static image',
        containerTitle: headline,
        verticalPosition,
        horizontalPosition: `${index + 1}`,
        title: seriesName || name,
        subtitle,
        cc: 'cc off',
        volume: 'volume off',
        collectionTitle: headline,
        collectionType,
        playlistLength: totalItems,
        collectionCount: totalCollections,
        item,
        visibleCollections,
      });
    };
    const onTileClick = props => {
      const { item, itemIndex } = props;
      if (onSelection) onSelection({ itemIndex });
      const itemIsLive = isLive(_.get(item, '@type'));
      if (autoplayEnabled()) {
        const source = PAGE_COLLECTION;
        removeGlobalVideoPlayer({ source });
      }
      if (!EpgEnabled && itemIsLive) saveLiveVideo(item);
      tealiumTileClick(props);
    };
    const items = addSeeMoreItem({ items: videoItems, collectionCTA, isFirst });
    const carouselProps = {
      useScrollableDiv,
      addCarouselPlaceholders,
      allowScrollLock,
      panelIdx: idx,
      isInfinite: false,
      slidesToShow: carouselLimit,
      slidesToScroll,
      showCarouselArrows,
      headline,
      featuredTitleImage,
      isFirst,
      panel,
      beforeChange: this.updateVisibleSlides,
      updateVisibleSlides: this.updateVisibleSlides,
      disableScroll,
    };

    return (
      <div key="tile-carousel">
        <div className={CarouselTheme.container}>
          <CollectionCarousel {...carouselProps} data-test="web-carousel">
            {items.map((item, idx) => {
              const props = {
                breakpoint,
                favoritesManager,
                item,
                itemIndex: idx,
                key: `collection-tile-${_.get(item, '@id', idx)}`,
                onTileClick: () => onTileClick({ item, itemIndex: idx }),
                showTileMetadataOnHover,
                toggleUpcomingOverlay: useMobileUpcomingOverlay ? this.toggleUpcomingOverlay : null,
              };
              if (isGenreCollection || _.get(item, '@type') === 'seeMore') {
                return <CollectionLinkTile {...props} />;
              }
              return <CollectionTile {...props} />;
            })}
          </CollectionCarousel>
        </div>
      </div>
    );
  }

  renderUpcomingOverlay = () => {
    const { breakpoint, favoritesManager, upcomingOverlayOpen, isUpcomingOverlayOpen } = this.props;
    const { overlayItemProps } = this.state;
    const closeOverlay = () => {
      this.setState({ overlayItemProps: false });
      upcomingOverlayOpen(false);
    };
    const originalItem = _.get(overlayItemProps, 'originalItem', false);
    if (isUpcomingOverlayOpen && originalItem) {
      if (isMobileBreakpoint(breakpoint) || breakpoint === SITE_PLATFORM_TABLET) {
        return (
          <UpcomingModal
            data-test="home-upcoming-modal"
            favoritesManager={favoritesManager}
            {...overlayItemProps}
            {...originalItem}
            closeOverlay={closeOverlay}
          />
        );
      }
    }
    return null;
  };

  renderVideoHero() {
    const { load: playerLoad, play: playerPlay, activeSlide } = this.state;
    const {
      panels,
      breakpoint,
      overlay,
      setVideoHero,
      removeVideoHero,
      paginatedPanels,
      hideHeaderImageAndVideo,
    } = this.props;
    const { backgroundVideoLoops } = window.ExternalConfig;
    const { videoBackground } = BREAKPOINTS[breakpoint];
    if (
      !panels ||
      panels.length === 0 ||
      !videoBackground ||
      overlay === OVERLAY_ALL_COLLECTIONS ||
      hideHeaderImageAndVideo
    ) {
      return null;
    }

    let item = _.get(panels, `member.${activeSlide}.items.member.0`, null);
    if (!item) {
      const activeSlideId = _.get(panels, `member.${activeSlide}.id`);
      item = _.get(paginatedPanels, `${activeSlideId}.panelData.items.member.0`, null);
      if (!item) return null;
    }

    const autoPlayVideo = videoBackground ? _.get(item, 'autoPlayVideo.default.url') : null;
    const autoPlayStill =
      _.get(item, 'autoPlayStill.default.url') || _.get(item, 'images.promoImage');
    // sent as image prop to VideoHero, commented out for now
    // const autoPlayStill = this.getHeroImage(activeSlide);

    return (
      <VideoHero
        key="home-video-hero"
        backgroundVideoLoops={backgroundVideoLoops}
        onMount={setVideoHero}
        onUnmount={removeVideoHero}
        video={autoPlayVideo}
        transitionImage={autoPlayStill}
        image={autoPlayStill}
        renderImage={image =>
          renderImage({
            breakpoint,
            imageType: COLLECTION_HERO_IMAGE,
            ...image,
          })
        }
        id="video-hero-home"
        load={playerLoad}
        play={playerPlay && !overlay}
        loop
        timer={0}
      />
    );
  }

  renderVideoModal() {
    const { shouldRenderVideoModal, videoModalId, videoModalData } = this.state;
    if (!shouldRenderVideoModal) return null;

    const defaultVideoContainerProps = this.getDefaultVideoContainerProps();
    return (
      <VideoModal
        {...defaultVideoContainerProps}
        key="home-video-modal"
        data-test="home-video-modal"
        toggleVideoModal={this.toggleVideoModal}
        videoData={videoModalData}
        videoId={videoModalId}
      />
    );
  }

  render() {
    const {
      accessToken,
      account,
      deviceId,
      disableScroll,
      errors,
      location,
      profileId,
      seo,
    } = this.props;
    const { showcase } = this.state;
    const networksBar = window.ExternalConfig.networkNavigation;
    const redesignClasses = Style.redesignScreenStyle;
    const pathName = _.get(location, 'pathname');
    const isHome = isHomeRoute(pathName);

    if (errors) return getErrorComponent(errors);
    const WebsiteSchema = { item: {}, type: SCHEMA_TYPES.WEBSITE };
    const OrganizationScheme = { item: {}, type: SCHEMA_TYPES.ORGANIZATION };
    const schemas = [WebsiteSchema, OrganizationScheme];
    return (
      <div
        className={classNames(
          showcase ? null : Style.noShowcase,
          redesignClasses,
          Style.screen,
          networksBar ? Style.withNetwoksBar : '',
        )}
      >
        <Seo seo={seo} />
        {isHome ? <Schema schemas={schemas} /> : null}
        {this.renderUpcomingOverlay()}
        {this.renderContent()}
        {this.renderAnonymousView()}

        {isHome && account && (
          <SuccessModal
            accessToken={accessToken}
            deviceId={deviceId}
            disableScroll={disableScroll}
            profileId={profileId}
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { collection, canIAutoplay, globalVideo } = state;

  return {
    bookmarks: collection.bookmarks,
    canIAutoplay: canIAutoplay.result,
    collectionOrder: makeSelectCollectionOrder(state),
    errors: collection.errors,
    forceKeyartForShowcase: collection.forceKeyartForShowcase,
    globalVideoStartedPlayback: globalVideo.startedPlayback,
    hideHeaderImageAndVideo: !!globalVideo.video,
    initialShowcase: makeSelectInitialShowcase(state),
    paginatedPanels: makeSelectPanelPanels(state),
    panelVideo: makeSelectGlobalVideoPanelVideo(state),
    panels: makeSelectCollectionPanels(state),
    fetching: state.panel.fetching,
    isPanelLoaded: collection.isPanelLoaded,
    panelRenderCount: collection.panelRenderCount,
    seo: collection.seo,
    showcaseFallback: collection.showcaseFallback,
    streamExit: globalVideo.streamExit,
    useShowcaseFallback: collection.useShowcaseFallback,
    video: globalVideo.video,
    videoIsLive: globalVideo.videoIsLive,
    visibleCollections: makeSelectVisibleCollections(state),
  };
}

Collection.fetchData = ({ store, screenUrl, currentRoute, accessToken }) => {
  const { isForgotPassword } = currentRoute || {};
  if (isForgotPassword) return null;
  isInitialized = true;
  return store.dispatch(dispatch =>
    dispatch(
      fetchCollections({
        path: screenUrl,
        panelsToPrefetch: FETCH_COLLECTION_MAX_PANELS_PREFETCH,
        accessToken,
      }),
    ),
  );
};

Collection.defaultProps = {
  accessToken: null,
  account: null,
  adblock: false,
  analyticsLoaded: false,
  anonymousAccount: null,
  anonymousId: null,
  authCheckComplete: null,
  authSuccess: null,
  blackoutConfig: {},
  blackoutDefinitions: {},
  bookmarks: {},
  canIAutoplay: null,
  clearCollectionPanels: noop,
  clearInterval: noop,
  clearTimeout: noop,
  collectionImpressionCalled: noop,
  collectionOrder: [],
  coordinates: null,
  deviceId: null,
  disableScroll: noop,
  errors: null,
  favoritesManager: {},
  fetchCollectionPanel: noop,
  fetchCollections: noop,
  firstCollectionImpression: false,
  forceKeyartForShowcase: null,
  globalVideoStartedPlayback: null,
  hideHeaderImageAndVideo: false,
  incrementPanelRenderCount: noop,
  initialShowcase: null,
  isAuthenticated: false,
  isPanelLoaded: false,
  isStatic: false,
  isUpcomingOverlayOpen: false,
  location: {},
  mvpdData: null,
  onAuthCheckComplete: noop,
  openForgotPassword: noop,
  openSignIn: noop,
  openSignUp: noop,
  optimizely: {},
  overlay: null,
  paginatedPanels: {},
  panelRenderCount: null,
  panels: {},
  panelVideo: {},
  params: { network: null },
  preauthorizedResources: [],
  profileId: null,
  provider: {},
  resetPanelLoaded: noop,
  resetPanelRenderCount: null,
  route: {},
  seo: null,
  setAccountCloseIgnoreRedirect: noop,
  setAuthorizationToken: noop,
  setBlockMVPDIncomplete: noop,
  setCoordinates: noop,
  setFreemiumModalVisibility: noop,
  setGlobalPlayerScreenInControlOfState: noop,
  setGlobalPlayerType: noop,
  setGlobalVideoDisabled: noop,
  setGlobalVideoPanel: noop,
  setHomePage: noop,
  setInterval: noop,
  setIsAuthenticated: false,
  setIsPlayerLoaded: noop,
  setLoading: null,
  setMVPDToAppState: noop,
  setOverlay: noop,
  setProvider: noop,
  setTimeout: noop,
  setUseShowcaseFallback: noop,
  showcaseFallback: '',
  streamExit: null,
  toggleMvpdAuthOverlay: noop,
  triggerAuthCheck: false,
  upcomingOverlayOpen: noop,
  updateCollectionOrder: noop,
  updateVisibleElements: noop,
  useShowcaseFallback: null,
  visibleCollections: {},
};

Collection.propTypes = {
  accessToken: PropTypes.string,
  account: PropTypes.shape({
    accessToken: PropTypes.string,
  }),
  adblock: PropTypes.bool,
  analyticsLoaded: PropTypes.bool,
  anonymousAccount: PropTypes.shape({}),
  anonymousId: PropTypes.string,
  anonymousLogin: PropTypes.func.isRequired,
  authCheckComplete: PropTypes.bool,
  authSuccess: PropTypes.bool,
  blackoutConfig: PropTypes.shape({}),
  blackoutDefinitions: PropTypes.shape({}),
  bookmarks: PropTypes.shape({}),
  breakpoint: PropTypes.string.isRequired,
  canIAutoplay: PropTypes.bool,
  clearCollectionPanels: PropTypes.func,
  clearInterval: PropTypes.func,
  clearTimeout: PropTypes.func,
  collectionImpressionCalled: PropTypes.func,
  collectionOrder: PropTypes.arrayOf(PropTypes.string),
  coordinates: PropTypes.shape({}),
  deviceId: PropTypes.string,
  disableScroll: PropTypes.func,
  errors: PropTypes.number,
  favoritesManager: PropTypes.shape({}),
  fetchCollectionPanel: PropTypes.func,
  fetchCollections: PropTypes.func,
  firstCollectionImpression: PropTypes.bool,
  firstIdentifyCall: PropTypes.bool.isRequired,
  forceKeyartForShowcase: PropTypes.bool,
  getUseUtagGlobal: PropTypes.func.isRequired,
  globalVideoStartedPlayback: PropTypes.bool,
  hasAccountOrProvider: PropTypes.bool,
  hideHeaderImageAndVideo: PropTypes.bool,
  incrementPanelRenderCount: PropTypes.func,
  initialShowcase: PropTypes.shape({}),
  isAuthenticated: PropTypes.bool,
  isFreemium: PropTypes.bool,
  isPanelLoaded: PropTypes.bool,
  isStatic: PropTypes.bool,
  isUpcomingOverlayOpen: PropTypes.bool,
  location: PropTypes.shape({}),
  mvpdData: PropTypes.shape({}),
  onAuthCheckComplete: PropTypes.func,
  openForgotPassword: PropTypes.func,
  openSignIn: PropTypes.func,
  openSignUp: PropTypes.func,
  optimizely: PropTypes.shape({}),
  overlay: PropTypes.string,
  pageViewEvent: PropTypes.func.isRequired,
  paginatedPanels: PropTypes.shape({}),
  panelVideo: PropTypes.shape({}),
  params: PropTypes.shape({
    network: PropTypes.string,
  }),
  panelRenderCount: PropTypes.number,
  panels: PropTypes.shape({
    itemsPerPage: PropTypes.number,
    member: PropTypes.arrayOf(PropTypes.shape({})),
    totalItems: PropTypes.number,
  }),
  preauthorizedResources: PropTypes.arrayOf(PropTypes.string),
  profileBookmarks: PropTypes.shape({}),
  profileId: PropTypes.string,
  provider: PropTypes.shape({}),
  removeGlobalVideoPlayer: PropTypes.func.isRequired,
  removeVideoHero: PropTypes.func.isRequired,
  renderAuthContainer: PropTypes.func.isRequired,
  resetPanelLoaded: PropTypes.func,
  resetPanelRenderCount: PropTypes.func,
  route: PropTypes.shape({}),
  router: PropTypes.shape({}).isRequired,
  saveGlobalLiveRestart: PropTypes.func.isRequired,
  saveLiveVideo: PropTypes.func.isRequired,
  seo: PropTypes.shape({}),
  setAccountCloseIgnoreRedirect: PropTypes.func,
  setAuthorizationToken: PropTypes.func,
  setBlockMVPDIncomplete: PropTypes.func,
  setCoordinates: PropTypes.func,
  setUserBookmarks: PropTypes.func.isRequired,
  setFreemiumModalVisibility: PropTypes.func,
  setGlobalPlayerScreenInControlOfState: PropTypes.func,
  setGlobalPlayerType: PropTypes.func,
  setGlobalVideoDisabled: PropTypes.func,
  setGlobalVideoPanel: PropTypes.func,
  setHomePage: PropTypes.func,
  setInterval: PropTypes.func,
  setIsAuthenticated: PropTypes.func,
  setIsPlayerLoaded: PropTypes.func,
  setLoading: PropTypes.func,
  setMVPDToAppState: PropTypes.func,
  setOverlay: PropTypes.func,
  setProvider: PropTypes.func,
  setRecommendationId: PropTypes.func.isRequired,
  setSuggestedChannel: PropTypes.func.isRequired,
  setTimeout: PropTypes.func,
  setUseShowcaseFallback: PropTypes.func,
  setVideoHero: PropTypes.func.isRequired,
  showcaseFallback: PropTypes.string,
  streamExit: PropTypes.bool,
  toggleMvpdAuthOverlay: PropTypes.func,
  triggerAuthCheck: PropTypes.bool,
  upcomingOverlayOpen: PropTypes.func,
  updateCollectionOrder: PropTypes.func,
  updateVisibleElements: PropTypes.func,
  useShowcaseFallback: PropTypes.bool,
  videoIsLive: PropTypes.bool.isRequired,
  visibleCollections: PropTypes.shape({}),
};

const TimeoutCollection = ReactTimeout(
  connect(mapStateToProps, {
    clearCollectionPanels,
    fetchCollectionPanel,
    fetchCollections,
    incrementPanelRenderCount,
    removeGlobalVideoPlayer,
    resetPanelLoaded,
    resetPanelRenderCount,
    saveGlobalLiveRestart,
    saveLiveVideo,
    setGlobalPlayerScreenInControlOfState,
    setGlobalPlayerType,
    setGlobalVideoDisabled,
    setGlobalVideoPanel,
    setRecommendationId,
    setSuggestedChannel,
    setUserBookmarks,
    setUseShowcaseFallback,
    updateCollectionOrder,
    updateVisibleElements,
  })(Collection),
);

TimeoutCollection.fetchData = Collection.fetchData;

export default TimeoutCollection;
